import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { FiSearch, FiRefreshCw, FiFilter, FiChevronDown, FiChevronUp, FiEye, FiX, FiCalendar, FiUsers, FiPackage, FiShoppingBag, FiImage, FiStar, FiDownload, FiShield, FiPlus, FiUpload, FiTrash2, FiEdit, FiCopy } from 'react-icons/fi';
import { BiSortAlt2 } from 'react-icons/bi';
import { BsCheckCircleFill, BsXCircleFill } from 'react-icons/bs';
import { exportToCSV } from '../utils/csvExport';
import axios from 'axios';
import VendorServicesTab from './VendorServicesTab';
import SpecialistsTab from './SpecialistsTab';
import VendorGalleryTab from './VendorGalleryTab';


const VendorsList = () => {
  // State variables
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalVendors, setTotalVendors] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState('');
  const [sortField, setSortField] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState('desc');
  const [exportLoading, setExportLoading] = useState(false);

  const [locationName, setLocationName] = useState(''); 
  // Filter states
  const [categoryFilter, setCategoryFilter] = useState('');
  const [approvalFilter, setApprovalFilter] = useState('');
  const [vendorTypeFilter, setVendorTypeFilter] = useState('');
  const [registrationFilter, setRegistrationFilter] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  // Selected vendor details modal state
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const [vendorDetailsModalOpen, setVendorDetailsModalOpen] = useState(false);
  const [updatingApproval, setUpdatingApproval] = useState(false);
  const [updatingVerified, setUpdatingVerified] = useState(false);
  const [activeTab, setActiveTab] = useState('basic'); // 'basic', 'services', 'specialists', 'bookings', 'reviews'
  const [vendorDetailsLoading, setVendorDetailsLoading] = useState(false);

  // Add Vendor Modal State
  const [showAddVendorModal, setShowAddVendorModal] = useState(false);
  const [addVendorLoading, setAddVendorLoading] = useState(false);
  const [amenitiesList, setAmenitiesList] = useState([]);
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [storeImageFiles, setStoreImageFiles] = useState([]);
  const [addressSearch, setAddressSearch] = useState('');
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [searchingAddress, setSearchingAddress] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState('');
  const [newVendor, setNewVendor] = useState({
    phone: '',
    name: '',
    store_name: '',
    email: '',
    category: 'unisex',
    description: '',
    vendorType: 'office',
    latitude: '',
    longitude: '',
    slot_duration: 30,
    slots_per_time: 4,
    working_hours: [
      { day: 'Monday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Tuesday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Wednesday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Thursday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Friday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Saturday', open: '10:00', close: '16:00', isOpen: true },
      { day: 'Sunday', open: '10:00', close: '16:00', isOpen: false }
    ],
    amenities: [],
    bank_details: {
      account_holder_name: '',
      account_number: '',
      ifsc_code: '',
      bank_name: '',
      branch_name: ''
    },
    approval: true,
    verified: true
  });

  // Edit Vendor Modal State
  const [showEditVendorModal, setShowEditVendorModal] = useState(false);
  const [editVendorLoading, setEditVendorLoading] = useState(false);
  const [editProfileImageFile, setEditProfileImageFile] = useState(null);
  const [editStoreImageFiles, setEditStoreImageFiles] = useState([]);
  const [editAddressSearch, setEditAddressSearch] = useState('');
  const [editAddressSuggestions, setEditAddressSuggestions] = useState([]);
  const [editSearchingAddress, setEditSearchingAddress] = useState(false);
  const [editSelectedAddress, setEditSelectedAddress] = useState('');
  const [existingStoreImages, setExistingStoreImages] = useState([]);
  const [editVendor, setEditVendor] = useState({
    _id: '',
    phone: '',
    name: '',
    store_name: '',
    email: '',
    category: 'unisex',
    description: '',
    vendorType: 'office',
    latitude: '',
    longitude: '',
    slot_duration: 30,
    slots_per_time: 4,
    working_hours: [
      { day: 'Monday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Tuesday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Wednesday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Thursday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Friday', open: '09:00', close: '18:00', isOpen: true },
      { day: 'Saturday', open: '10:00', close: '16:00', isOpen: true },
      { day: 'Sunday', open: '10:00', close: '16:00', isOpen: false }
    ],
    amenities: [],
    bank_details: {
      account_holder_name: '',
      account_number: '',
      ifsc_code: '',
      bank_name: '',
      branch_name: ''
    },
    approval: true,
    verified: true,
    registrationComplete: false
  });

  // Delete Vendor Modal State
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');
  const [deletingVendor, setDeletingVendor] = useState(false);

  // Duplicate Vendor Modal State
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateLoading, setDuplicateLoading] = useState(false);
  const [duplicateSource, setDuplicateSource] = useState(null);
  const [duplicateForm, setDuplicateForm] = useState({
    phone: '',
    store_name: '',
    name: '',
    email: '',
    latitude: '',
    longitude: ''
  });
  const [duplicateAddressSearch, setDuplicateAddressSearch] = useState('');
  const [duplicateAddressSuggestions, setDuplicateAddressSuggestions] = useState([]);
  const [duplicateSearchingAddress, setDuplicateSearchingAddress] = useState(false);
  const [duplicateSelectedAddress, setDuplicateSelectedAddress] = useState('');


  // Fetch amenities for the dropdown
  const fetchAmenities = async () => {
    try {
      const response = await api.get('/admin/amenities');
      if (response.data.success) {
        setAmenitiesList(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching amenities:', error);
    }
  };

  // Search for address suggestions using Google Maps Places API
  const searchAddress = async (query) => {
    if (!query || query.length < 3) {
      setAddressSuggestions([]);
      return;
    }

    setSearchingAddress(true);
    try {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        { input: query, componentRestrictions: { country: 'in' } },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            setAddressSuggestions(predictions.map(item => ({
              display_name: item.description,
              place_id: item.place_id
            })));
          } else {
            setAddressSuggestions([]);
          }
          setSearchingAddress(false);
        }
      );
    } catch (error) {
      console.error('Error searching address:', error);
      setAddressSuggestions([]);
      setSearchingAddress(false);
    }
  };

  // Handle address selection - get lat/lng from place_id using Geocoder
  const handleAddressSelect = (address) => {
    setSelectedAddress(address.display_name);
    setAddressSearch(address.display_name);
    setAddressSuggestions([]);

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: address.place_id }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        setNewVendor(prev => ({
          ...prev,
          latitude: location.lat().toString(),
          longitude: location.lng().toString()
        }));
      }
    });
  };

  // Reset new vendor form
  const resetNewVendorForm = () => {
    setNewVendor({
      phone: '',
      name: '',
      store_name: '',
      email: '',
      category: 'unisex',
      description: '',
      vendorType: 'office',
      latitude: '',
      longitude: '',
      slot_duration: 30,
      slots_per_time: 4,
      working_hours: [
        { day: 'Monday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Tuesday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Wednesday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Thursday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Friday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Saturday', open: '10:00', close: '16:00', isOpen: true },
        { day: 'Sunday', open: '10:00', close: '16:00', isOpen: false }
      ],
      amenities: [],
      bank_details: {
        account_holder_name: '',
        account_number: '',
        ifsc_code: '',
        bank_name: '',
        branch_name: ''
      },
      approval: true,
      verified: true
    });
    setProfileImageFile(null);
    setStoreImageFiles([]);
    setAddressSearch('');
    setAddressSuggestions([]);
    setSelectedAddress('');
  };

  // Handle creating a new vendor
  const handleCreateVendor = async (e) => {
    e.preventDefault();

    if (!newVendor.phone) {
      alert('Phone number is required');
      return;
    }

    setAddVendorLoading(true);

    try {
      const token = localStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api.bookwie.com';

      const formData = new FormData();

      // Add basic fields
      formData.append('phone', newVendor.phone);
      if (newVendor.name) formData.append('name', newVendor.name);
      if (newVendor.store_name) formData.append('store_name', newVendor.store_name);
      if (newVendor.email) formData.append('email', newVendor.email);
      if (newVendor.category) formData.append('category', newVendor.category);
      if (newVendor.description) formData.append('description', newVendor.description);
      if (newVendor.vendorType) formData.append('vendorType', newVendor.vendorType);
      if (newVendor.latitude) formData.append('latitude', newVendor.latitude);
      if (newVendor.longitude) formData.append('longitude', newVendor.longitude);
      formData.append('address', selectedAddress || '');
      formData.append('slot_duration', newVendor.slot_duration);
      formData.append('slots_per_time', newVendor.slots_per_time);
      formData.append('approval', newVendor.approval);
      formData.append('verified', newVendor.verified);

      // Add working hours (only open days)
      const activeWorkingHours = newVendor.working_hours
        .filter(wh => wh.isOpen)
        .map(({ day, open, close }) => ({ day, open, close }));
      formData.append('working_hours', JSON.stringify(activeWorkingHours));

      // Add amenities
      if (newVendor.amenities.length > 0) {
        formData.append('amenities', JSON.stringify(newVendor.amenities));
      }

      // Add bank details if any field is filled
      const bankDetails = newVendor.bank_details;
      if (bankDetails.account_number || bankDetails.ifsc_code) {
        formData.append('bank_details', JSON.stringify(bankDetails));
      }

      // Add profile image
      if (profileImageFile) {
        formData.append('profile_image', profileImageFile);
      }

      // Add store images
      storeImageFiles.forEach(file => {
        formData.append('store_images', file);
      });

      const response = await axios.post(`${apiUrl}/api/admin/vendor/create`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        alert('Vendor created successfully!');
        setShowAddVendorModal(false);
        resetNewVendorForm();
        fetchVendors(); // Refresh the list
      }
    } catch (error) {
      console.error('Error creating vendor:', error);
      alert(error.response?.data?.message || 'Failed to create vendor');
    } finally {
      setAddVendorLoading(false);
    }
  };

  // Open Add Vendor Modal
  const openAddVendorModal = () => {
    fetchAmenities();
    setShowAddVendorModal(true);
  };

  // Search for address suggestions for Edit Modal using Google Maps Places API
  const searchEditAddress = async (query) => {
    if (!query || query.length < 3) {
      setEditAddressSuggestions([]);
      return;
    }

    setEditSearchingAddress(true);
    try {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        { input: query, componentRestrictions: { country: 'in' } },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            setEditAddressSuggestions(predictions.map(item => ({
              display_name: item.description,
              place_id: item.place_id
            })));
          } else {
            setEditAddressSuggestions([]);
          }
          setEditSearchingAddress(false);
        }
      );
    } catch (error) {
      console.error('Error searching address:', error);
      setEditAddressSuggestions([]);
      setEditSearchingAddress(false);
    }
  };

  // Handle address selection for Edit Modal - get lat/lng from place_id
  const handleEditAddressSelect = (address) => {
    setEditSelectedAddress(address.display_name);
    setEditAddressSearch(address.display_name);
    setEditAddressSuggestions([]);

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: address.place_id }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        setEditVendor(prev => ({
          ...prev,
          latitude: location.lat().toString(),
          longitude: location.lng().toString()
        }));
      }
    });
  };

  // Open Edit Vendor Modal
  const openEditVendorModal = async (vendor) => {
    fetchAmenities();

    // Prepare working hours with isOpen flag
    const defaultWorkingHours = [
      { day: 'Monday', open: '09:00', close: '18:00', isOpen: false },
      { day: 'Tuesday', open: '09:00', close: '18:00', isOpen: false },
      { day: 'Wednesday', open: '09:00', close: '18:00', isOpen: false },
      { day: 'Thursday', open: '09:00', close: '18:00', isOpen: false },
      { day: 'Friday', open: '09:00', close: '18:00', isOpen: false },
      { day: 'Saturday', open: '10:00', close: '16:00', isOpen: false },
      { day: 'Sunday', open: '10:00', close: '16:00', isOpen: false }
    ];

    // Merge vendor's working hours with default
    const vendorWorkingHours = vendor.working_hours || [];
    const mergedWorkingHours = defaultWorkingHours.map(defaultDay => {
      const vendorDay = vendorWorkingHours.find(wh => wh.day === defaultDay.day);
      if (vendorDay) {
        return { ...defaultDay, ...vendorDay, isOpen: true };
      }
      return defaultDay;
    });

    // Extract amenity IDs
    const amenityIds = vendor.amenities || [];
    const amenityIdsArray = amenityIds.map(a => typeof a === 'object' ? a._id : a);

    setEditVendor({
      _id: vendor._id,
      phone: vendor.phone || '',
      name: vendor.name || '',
      store_name: vendor.store_name || '',
      email: vendor.email || '',
      category: vendor.category || 'unisex',
      description: vendor.description || '',
      vendorType: vendor.vendorType || 'office',
      latitude: vendor.latitude || '',
      longitude: vendor.longitude || '',
      slot_duration: vendor.slot_duration || 30,
      slots_per_time: vendor.slots_per_time || 4,
      working_hours: mergedWorkingHours,
      amenities: amenityIdsArray,
      bank_details: {
        account_holder_name: vendor.bank_details?.account_holder_name || '',
        account_number: vendor.bank_details?.account_number || '',
        ifsc_code: vendor.bank_details?.ifsc_code || '',
        bank_name: vendor.bank_details?.bank_name || '',
        branch_name: vendor.bank_details?.branch_name || ''
      },
      approval: vendor.approval ?? true,
      verified: vendor.verified ?? false,
      registrationComplete: vendor.registrationComplete ?? false
    });

    // Set existing store images
    setExistingStoreImages(vendor.store_images || []);
    setEditStoreImageFiles([]);
    setEditProfileImageFile(null);

    // Use stored address if available, otherwise reverse geocode
    if (vendor.address) {
      setEditSelectedAddress(vendor.address);
      setEditAddressSearch(vendor.address);
    } else if (vendor.latitude && vendor.longitude) {
      try {
        const geocoder = new window.google.maps.Geocoder();
        const latlng = { lat: parseFloat(vendor.latitude), lng: parseFloat(vendor.longitude) };
        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === 'OK' && results[0]) {
            setEditSelectedAddress(results[0].formatted_address);
            setEditAddressSearch(results[0].formatted_address);
          }
        });
      } catch (error) {
        console.error('Error getting address:', error);
      }
    } else {
      setEditSelectedAddress('');
      setEditAddressSearch('');
    }

    setShowEditVendorModal(true);
  };

  // Reset Edit Vendor Form
  const resetEditVendorForm = () => {
    setEditVendor({
      _id: '',
      phone: '',
      name: '',
      store_name: '',
      email: '',
      category: 'unisex',
      description: '',
      vendorType: 'office',
      latitude: '',
      longitude: '',
      slot_duration: 30,
      slots_per_time: 4,
      working_hours: [
        { day: 'Monday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Tuesday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Wednesday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Thursday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Friday', open: '09:00', close: '18:00', isOpen: true },
        { day: 'Saturday', open: '10:00', close: '16:00', isOpen: true },
        { day: 'Sunday', open: '10:00', close: '16:00', isOpen: false }
      ],
      amenities: [],
      bank_details: {
        account_holder_name: '',
        account_number: '',
        ifsc_code: '',
        bank_name: '',
        branch_name: ''
      },
      approval: true,
      verified: true,
      registrationComplete: false
    });
    setEditProfileImageFile(null);
    setEditStoreImageFiles([]);
    setExistingStoreImages([]);
    setEditAddressSearch('');
    setEditAddressSuggestions([]);
    setEditSelectedAddress('');
  };

  // Handle updating vendor
  const handleUpdateVendor = async (e) => {
    e.preventDefault();

    if (!editVendor._id) {
      alert('Vendor ID is missing');
      return;
    }

    if (!/^[0-9]{10}$/.test(editVendor.phone || '')) {
      alert('Phone number must be a valid 10-digit number');
      return;
    }

    setEditVendorLoading(true);

    try {
      const token = localStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api.bookwie.com';

      const formData = new FormData();

      // Add basic fields
      formData.append('phone', editVendor.phone);
      formData.append('name', editVendor.name || '');
      formData.append('store_name', editVendor.store_name || '');
      formData.append('email', editVendor.email || '');
      formData.append('category', editVendor.category || '');
      formData.append('description', editVendor.description || '');
      formData.append('vendorType', editVendor.vendorType || '');
      if (editVendor.latitude) formData.append('latitude', editVendor.latitude);
      if (editVendor.longitude) formData.append('longitude', editVendor.longitude);
      formData.append('address', editSelectedAddress || '');
      formData.append('slot_duration', editVendor.slot_duration);
      formData.append('slots_per_time', editVendor.slots_per_time);
      formData.append('approval', editVendor.approval);
      formData.append('verified', editVendor.verified);
      formData.append('registrationComplete', editVendor.registrationComplete);

      // Add working hours (only open days)
      const activeWorkingHours = editVendor.working_hours
        .filter(wh => wh.isOpen)
        .map(({ day, open, close }) => ({ day, open, close }));
      formData.append('working_hours', JSON.stringify(activeWorkingHours));

      // Add amenities
      if (editVendor.amenities.length > 0) {
        formData.append('amenities', JSON.stringify(editVendor.amenities));
      }

      // Add bank details if any field is filled
      const bankDetails = editVendor.bank_details;
      if (bankDetails.account_number || bankDetails.ifsc_code) {
        formData.append('bank_details', JSON.stringify(bankDetails));
      }

      // Add new profile image if selected
      if (editProfileImageFile) {
        formData.append('profile_image', editProfileImageFile);
      }

      // Add new store images
      editStoreImageFiles.forEach(file => {
        formData.append('store_images', file);
      });

      // Keep existing store images (send their URLs)
      if (existingStoreImages.length > 0) {
        formData.append('existing_store_images', JSON.stringify(existingStoreImages));
      }

      const response = await axios.put(`${apiUrl}/api/admin/vendor/${editVendor._id}`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        alert('Vendor updated successfully!');
        setShowEditVendorModal(false);
        resetEditVendorForm();
        fetchVendors(); // Refresh the list

        // Also close the details modal if open and refresh its data
        if (vendorDetailsModalOpen && selectedVendor?._id === editVendor._id) {
          closeVendorDetailsModal();
        }
      }
    } catch (error) {
      console.error('Error updating vendor:', error);
      alert(error.response?.data?.message || 'Failed to update vendor');
    } finally {
      setEditVendorLoading(false);
    }
  };

 // Open Duplicate Vendor Modal — seed store_name/name/email from source, leave phone + location blank
  const openDuplicateModal = (vendor) => {
    setDuplicateSource(vendor);
    setDuplicateForm({
      phone: '',
      store_name: vendor.store_name || '',
      name: vendor.name || '',
      email: vendor.email || '',
      latitude: '',
      longitude: ''
    });
    setDuplicateAddressSearch('');
    setDuplicateAddressSuggestions([]);
    setDuplicateSelectedAddress('');
    setShowDuplicateModal(true);
  };

  const resetDuplicateForm = () => {
    setDuplicateSource(null);
    setDuplicateForm({ phone: '', store_name: '', name: '', email: '', latitude: '', longitude: '' });
    setDuplicateAddressSearch('');
    setDuplicateAddressSuggestions([]);
    setDuplicateSelectedAddress('');
  };

  const searchDuplicateAddress = async (query) => {
    if (!query || query.length < 3) {
      setDuplicateAddressSuggestions([]);
      return;
    }
    setDuplicateSearchingAddress(true);
    try {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        { input: query, componentRestrictions: { country: 'in' } },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            setDuplicateAddressSuggestions(predictions.map(item => ({
              display_name: item.description,
              place_id: item.place_id
            })));
          } else {
            setDuplicateAddressSuggestions([]);
          }
          setDuplicateSearchingAddress(false);
        }
      );
    } catch (error) {
      console.error('Error searching address:', error);
      setDuplicateAddressSuggestions([]);
      setDuplicateSearchingAddress(false);
    }
  };

  const handleDuplicateAddressSelect = (address) => {
    setDuplicateSelectedAddress(address.display_name);
    setDuplicateAddressSearch(address.display_name);
    setDuplicateAddressSuggestions([]);

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: address.place_id }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        setDuplicateForm(prev => ({
          ...prev,
          latitude: location.lat().toString(),
          longitude: location.lng().toString()
        }));
      }
    });
  };

  const handleDuplicateVendor = async (e) => {
    e.preventDefault();
    if (!duplicateSource?._id) {
      alert('Source vendor is missing');
      return;
    }
    if (!/^[0-9]{10}$/.test(duplicateForm.phone)) {
      alert('Please enter a valid 10-digit phone number for the new branch');
      return;
    }

    setDuplicateLoading(true);
    try {
      const payload = {
        phone: duplicateForm.phone,
        store_name: duplicateForm.store_name || undefined,
        name: duplicateForm.name || undefined,
        email: duplicateForm.email || undefined,
        address: duplicateSelectedAddress || undefined,
        latitude: duplicateForm.latitude || undefined,
        longitude: duplicateForm.longitude || undefined
      };

      const response = await api.post(`/admin/vendor/${duplicateSource._id}/duplicate`, payload);

      if (response.data.success) {
        const counts = response.data.data?.counts || {};
        alert(
          `Vendor duplicated successfully!\n\n` +
          `Copied: ${counts.services || 0} services, ${counts.specialists || 0} specialists, ` +
          `${counts.packages || 0} packages, ${counts.gallery || 0} gallery items, ` +
          `${counts.portfolio || 0} portfolio items, ${counts.addons || 0} add-ons.`
        );
        setShowDuplicateModal(false);
        resetDuplicateForm();
        fetchVendors();
      }
    } catch (error) {
      console.error('Error duplicating vendor:', error);
      alert(error.response?.data?.message || 'Failed to duplicate vendor');
    } finally {
      setDuplicateLoading(false);
    }
  };

 const exportToExcel = async () => {
  setExportLoading(true);

  try {
    // If we need all vendors (not just current page), fetch them
    let allVendors = vendors;

    // If you want to export all vendors with current filters, make API call
    if (totalVendors > vendors.length) {
      const token = localStorage.getItem('token');

      if (!token) {
        alert('Authentication token not found. Please log in again.');
        setExportLoading(false);
        return;
      }

      // Build query parameters for all vendors
      const params = {
        page: 1,
        limit: totalVendors, // Get all vendors
        sortBy: sortField,
        sortOrder: sortOrder
      };

      // Add filters if they exist
      if (search) params.search = search;
      if (categoryFilter) params.category = categoryFilter;
      if (approvalFilter !== '') params.approval = approvalFilter;
      if (vendorTypeFilter) params.vendorType = vendorTypeFilter;
      if (registrationFilter !== '') params.registrationComplete = registrationFilter;

      const apiUrl = process.env.REACT_APP_API_URL || 'https://api.bookwie.com';
      const response = await axios.get(`${apiUrl}/api/admin/vendor/list`, {
        params,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      allVendors = response.data.data.vendors;
    }

    // Function to get address from coordinates using Google Maps Geocoder
    const getAddressFromCoordinates = async (latitude, longitude) => {
      try {
        const geocoder = new window.google.maps.Geocoder();
        const latlng = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
        return new Promise((resolve) => {
          geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === 'OK' && results[0]) {
              resolve(results[0].formatted_address);
            } else {
              resolve('Address not found');
            }
          });
        });
      } catch (error) {
        console.error('Error getting address:', error);
        return 'Error getting address';
      }
    };

    // Fetch addresses for all vendors with coordinates
    const vendorsWithAddresses = await Promise.all(
      allVendors.map(async (vendor) => {
        let address = 'Location not set';

        if (vendor.latitude && vendor.longitude) {
          address = await getAddressFromCoordinates(vendor.latitude, vendor.longitude);
        }

        return { ...vendor, address };
      })
    );

    // Transform vendor data for CSV export
    const exportData = vendorsWithAddresses.map((vendor, index) => ({
      'S.No': index + 1,
      'Vendor ID': vendor._id,
      'Name': vendor.name || '',
      'Phone': vendor.phone || '',
      'Email': vendor.email || '',
      'Store Name': vendor.store_name || '',
      'Category': vendor.category || '',
      'Vendor Type': vendor.vendorType || '',
      'Approval Status': vendor.approval ? 'Approved' : 'Not Approved',
      'Registration Status': vendor.registrationComplete ? 'Complete' : 'Incomplete',
      'Address': vendor.address,
      'Slot Duration (min)': vendor.slot_duration || '',
      'Slots Per Time': vendor.slots_per_time || '',
      'Working Hours': vendor.working_hours ?
        vendor.working_hours.map(wh => `${wh.day}: ${wh.open}-${wh.close}`).join('; ') : '',
      'Amenities': vendor.amenitiesDetails ?
        vendor.amenitiesDetails.map(a => a.name).join(', ') : '',
      'Bank Account Holder': vendor.bank_details?.account_holder_name || '',
      'Bank Account Number': vendor.bank_details?.account_number || '',
      'Bank IFSC': vendor.bank_details?.ifsc_code || '',
      'Bank Name': vendor.bank_details?.bank_name || '',
      'Bank Branch': vendor.bank_details?.branch_name || '',
      'Verified Status': vendor.verified ? 'Verified' : 'Not Verified',
      'Store Images Count': vendor.store_images ? vendor.store_images.length : 0,
      'Device Count': vendor.devices ? vendor.devices.length : 0,
      'Created At': vendor.createdAt ? new Date(vendor.createdAt).toLocaleString() : '',
      'Updated At': vendor.updatedAt ? new Date(vendor.updatedAt).toLocaleString() : ''
    }));

    // Generate filename with current date
    const currentDate = new Date().toISOString().split('T')[0];
    const filename = `Vendors_Export_${currentDate}.csv`;

    // Export to CSV
    exportToCSV(exportData, filename);

    // Show success message
    alert(`${allVendors.length} vendors exported successfully with addresses!`);

  } catch (error) {
    console.error('Error exporting to Excel:', error);
    if (error.response && error.response.status === 401) {
      alert('Your session has expired. Please log in again.');
    } else {
      alert('Failed to export vendors data. Please try again.');
    }
  } finally {
    setExportLoading(false);
  }
};
  // Fetch vendors based on filters and pagination
  const fetchVendors = async () => {
    setLoading(true);
    try {
      // Build query parameters
      const params = {
        page: currentPage,
        limit: pageSize,
        sortBy: sortField,
        sortOrder: sortOrder
      };

      // Add filters if they exist
      if (search) params.search = search;
      if (categoryFilter) params.category = categoryFilter;
      if (approvalFilter !== '') params.approval = approvalFilter;
      if (vendorTypeFilter) params.vendorType = vendorTypeFilter;
      if (registrationFilter !== '') params.registrationComplete = registrationFilter;

      // Make API call using the new API utility (handles auth and 401 automatically)
      const response = await api.get('/admin/vendor/list', { params });
      
      // Update state with response data
      setVendors(response.data.data.vendors);
      setTotalVendors(response.data.data.pagination.totalVendors);
      setTotalPages(response.data.data.pagination.totalPages);
    } catch (error) {
      console.error('Error fetching vendors:', error);
      // 401 errors are handled automatically by the interceptor
      // Only handle other errors here
      if (error.response && error.response.status !== 401) {
        alert('Failed to fetch vendors data');
      }
    } finally {
      setLoading(false);
    }
  };

  // Update vendor approval status
  const updateVendorApproval = async (vendorId, approval) => {
    setUpdatingApproval(true);
    try {
      const response = await api.patch(
        '/admin/vendor/update-approval',
        { vendorId, approval }
      );

      // Update the vendor in the list
      if (response.data.success) {
        // Update the vendor in the vendors list
        setVendors(prevVendors =>
          prevVendors.map(vendor =>
            vendor._id === vendorId
              ? { ...vendor, approval }
              : vendor
          )
        );

        setSelectedVendor(prevSelected =>
          prevSelected && prevSelected._id === vendorId
            ? { ...prevSelected, approval }
            : prevSelected
        );

        setVendorData(prevVendorData => {
          if (prevVendorData && prevVendorData.vendor && prevVendorData.vendor._id === vendorId) {
            return {
              ...prevVendorData,
              vendor: {
                ...prevVendorData.vendor,
                approval
              }
            };
          }
          return prevVendorData;
        });

        alert(`Vendor ${approval ? 'approved' : 'rejected'} successfully`);
      }
    } catch (error) {
      console.error('Error updating vendor approval:', error);
      alert('Failed to update vendor approval status');
    } finally {
      setUpdatingApproval(false);
    }
  };

  // Update vendor verified status
  const updateVendorVerified = async (vendorId, verified) => {
    setUpdatingVerified(true);
    try {
      const response = await api.patch(
        '/admin/vendor/update-verified',
        { vendorId, verified }
      );

      if (response.data.success) {
        setVendors(prevVendors =>
          prevVendors.map(vendor =>
            vendor._id === vendorId
              ? { ...vendor, verified }
              : vendor
          )
        );

        setSelectedVendor(prevSelected =>
          prevSelected && prevSelected._id === vendorId
            ? { ...prevSelected, verified }
            : prevSelected
        );

        setVendorData(prevVendorData => {
          if (prevVendorData && prevVendorData.vendor && prevVendorData.vendor._id === vendorId) {
            return {
              ...prevVendorData,
              vendor: {
                ...prevVendorData.vendor,
                verified
              }
            };
          }
          return prevVendorData;
        });

        alert(`Vendor ${verified ? 'verified' : 'unverified'} successfully`);
      }
    } catch (error) {
      console.error('Error updating vendor verified status:', error);
      alert('Failed to update vendor verified status');
    } finally {
      setUpdatingVerified(false);
    }
  };

  // View vendor details
  const viewVendorDetails = async (vendor) => {
    setSelectedVendor(vendor);
    setVendorDetailsModalOpen(true);
    setActiveTab('basic');
    
    // Reset location name
    setLocationName('Loading location...');
    
    // If vendor has latitude and longitude, get the location name
    if (vendor.latitude && vendor.longitude) {
      getLocationName(vendor.latitude, vendor.longitude);
    } else {
      setLocationName('Location not set');
    }

    // Fetch detailed vendor data
    setVendorDetailsLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        alert('Authentication token not found. Please log in again.');
        return;
      }

      const apiUrl = process.env.REACT_APP_API_URL || 'https://api.bookwie.com';
      const response = await axios.get(
        `${apiUrl}/api/admin/vendor/${vendor._id}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      if (response.data.success) {
        setVendorData(response.data.data);
        // Update selectedVendor with detailed data so display fields (like location) are accurate
        const detailedVendor = response.data.data.vendor;
        if (detailedVendor) {
          setSelectedVendor(detailedVendor);
          // Re-check location with detailed data
          if (detailedVendor.latitude && detailedVendor.longitude) {
            getLocationName(detailedVendor.latitude, detailedVendor.longitude);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching vendor details:', error);
      alert('Failed to fetch complete vendor details');
    } finally {
      setVendorDetailsLoading(false);
    }
  };

  // Function to get location name from coordinates using Google Maps Geocoder
  const getLocationName = async (latitude, longitude) => {
    try {
      const geocoder = new window.google.maps.Geocoder();
      const latlng = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK' && results[0]) {
          setLocationName(results[0].formatted_address);
        } else {
          setLocationName('Address not found');
        }
      });
    } catch (error) {
      console.error('Error getting location name:', error);
      setLocationName('Error getting location');
    }
  };

  // Close vendor details modal
  const closeVendorDetailsModal = () => {
    setVendorDetailsModalOpen(false);
    setSelectedVendor(null);
    setVendorData(null);
    setActiveTab('basic');
  };

  const openDeleteVendorModal = (vendor) => {
    setDeleteTarget(vendor);
    setDeleteConfirmText('');
  };

  const closeDeleteVendorModal = () => {
    if (deletingVendor) return;
    setDeleteTarget(null);
    setDeleteConfirmText('');
  };

  // Permanently delete the vendor and its services, packages, specialists, gallery, reviews and wallet history.
  // The backend refuses while the vendor still has upcoming bookings.
  const handleDeleteVendor = async () => {
    if (!deleteTarget?._id || deleteConfirmText !== 'DELETE') return;

    setDeletingVendor(true);
    try {
      const response = await api.delete(`/admin/vendor/${deleteTarget._id}`);
      if (response.data.success) {
        const deletedId = deleteTarget._id;
        setVendors(prevVendors => prevVendors.filter(vendor => vendor._id !== deletedId));
        setDeleteTarget(null);
        setDeleteConfirmText('');
        closeVendorDetailsModal();
        alert('Vendor deleted permanently');
        fetchVendors();
      }
    } catch (error) {
      console.error('Error deleting vendor:', error);
      alert(error.response?.data?.message || 'Failed to delete vendor');
    } finally {
      setDeletingVendor(false);
    }
  };

  // Initial fetch and when dependencies change
  useEffect(() => {
    fetchVendors();
  }, [currentPage, pageSize, sortField, sortOrder, approvalFilter, categoryFilter, vendorTypeFilter, registrationFilter]);

  // Handle search with debounce
  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentPage(1); // Reset to first page when searching
      fetchVendors();
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  // Reset all filters
  const resetFilters = () => {
    setSearch('');
    setCategoryFilter('');
    setApprovalFilter('');
    setVendorTypeFilter('');
    setRegistrationFilter('');
    setSortField('createdAt');
    setSortOrder('desc');
    setCurrentPage(1);
  };

  // Handle sorting
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  // Get sort icon
  const getSortIcon = (field) => {
    if (sortField !== field) return <BiSortAlt2 className="ml-1" />;
    return sortOrder === 'asc' ? <FiChevronUp className="ml-1" /> : <FiChevronDown className="ml-1" />;
  };

  // Calculate pages for pagination
  const pagesToShow = [];
  const maxPagesToShow = 5;
  
  if (totalPages <= maxPagesToShow) {
    for (let i = 1; i <= totalPages; i++) {
      pagesToShow.push(i);
    }
  } else {
    const leftSide = Math.floor(maxPagesToShow / 2);
    const rightSide = maxPagesToShow - leftSide;

    if (currentPage <= leftSide) {
      for (let i = 1; i <= maxPagesToShow; i++) {
        pagesToShow.push(i);
      }
    } else if (currentPage >= totalPages - rightSide) {
      for (let i = totalPages - maxPagesToShow + 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      for (let i = currentPage - leftSide; i <= currentPage + rightSide; i++) {
        pagesToShow.push(i);
      }
    }
  }

  // Get category badge color
  const getCategoryColor = (category) => {
    switch (category) {
      case 'mens': return 'bg-blue-100 text-blue-800';
      case 'womens': return 'bg-pink-100 text-pink-800';
      case 'unisex': return 'bg-purple-100 text-purple-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Format time from HH:MM format
  const formatTime = (timeString) => {
    if (!timeString) return '';
    const [hours, minutes] = timeString.split(':');
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  };

  return (
    <div className="space-y-5">
      <div className="bg-white rounded-3xl shadow-card p-6">
        {/* Header */}
       <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-6 gap-4">
  <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-gray-900">Vendor Management</h1>

  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full lg:w-auto">
    {/* Add Vendor Button */}
    <button
      onClick={openAddVendorModal}
      className="flex items-center px-4 py-2 text-sm rounded-md bg-blue-500 hover:bg-blue-600 text-white font-medium"
    >
      <FiPlus className="mr-2" />
      Add Vendor
    </button>

    {/* Export Button */}
  <button
  onClick={exportToExcel}
  disabled={exportLoading || vendors.length === 0}
  className={`flex items-center px-3 py-1 text-sm rounded-md ${
    exportLoading || vendors.length === 0
      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
      : 'bg-green-100 hover:bg-green-200 text-green-800'
  }`}
>
  {exportLoading ? (
    <>
      <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-green-600 mr-1"></div>
      Exporting...
    </>
  ) : (
    <>
      <FiDownload className="mr-1" />
      Export Excel
    </>
  )}
</button>
    
    {/* Search */}
    <div className="w-full sm:w-64 relative">
      <input
        type="text"
        placeholder="Search by name, phone..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <FiSearch className="absolute left-3 top-3 text-gray-400" />
    </div>
  </div>
</div>

        {/* Filters */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-2">
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="flex items-center text-blue-600 hover:text-blue-800"
            >
              <FiFilter className="mr-1" />
              {showFilters ? 'Hide Filters' : 'Show Filters'}
            </button>
            
            <div className="flex items-center space-x-2">
              <button
                onClick={resetFilters}
                className="flex items-center px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-md"
              >
                <FiRefreshCw className="mr-1" /> Reset
              </button>
            </div>
          </div>
          
          {showFilters && (
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 p-4 bg-gray-50 rounded-lg mt-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                <select
                  value={categoryFilter}
                  onChange={(e) => setCategoryFilter(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">All Categories</option>
                  <option value="mens">Mens</option>
                  <option value="womens">Womens</option>
                  <option value="unisex">Unisex</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Approval Status</label>
                <select
                  value={approvalFilter}
                  onChange={(e) => setApprovalFilter(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">All Status</option>
                  <option value="true">Approved</option>
                  <option value="false">Not Approved</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Type</label>
                <select
                  value={vendorTypeFilter}
                  onChange={(e) => setVendorTypeFilter(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">All Types</option>
                  <option value="home">Home</option>
                  <option value="office">Office</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Registration</label>
                <select
                  value={registrationFilter}
                  onChange={(e) => setRegistrationFilter(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">All</option>
                  <option value="true">Complete</option>
                  <option value="false">Incomplete</option>
                </select>
              </div>
            </div>
          )}
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead>
              <tr className="bg-gray-100 border-b">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Profile
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Verified
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                    onClick={() => handleSort('name')}>
                  <div className="flex items-center">
                    Name {getSortIcon('name')}
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                    onClick={() => handleSort('store_name')}>
                  <div className="flex items-center">
                    Store Name {getSortIcon('store_name')}
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Registration
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                    onClick={() => handleSort('createdAt')}>
                  <div className="flex items-center">
                    Created {getSortIcon('createdAt')}
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="10" className="px-6 py-4 text-center">
                    <div className="flex justify-center items-center space-x-2">
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                      <span>Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : vendors.length === 0 ? (
                <tr>
                  <td colSpan="10" className="px-6 py-4 text-center text-gray-500">
                    No vendors found
                  </td>
                </tr>
              ) : (
                vendors.map((vendor) => (
                  <tr key={vendor._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      {vendor.profile_image ? (
                        <img
                          src={vendor.profile_image}
                          alt={vendor.name}
                          className="h-10 w-10 rounded-full object-cover"
                        />
                      ) : (
                        <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-sm font-medium">
                          {vendor.name?.charAt(0)?.toUpperCase() || '?'}
                        </div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        {vendor.verified ? (
                          <>
                            <FiShield className="text-blue-500 mr-1" />
                            <span className="text-sm text-blue-600">Verified</span>
                          </>
                        ) : (
                          <>
                            <FiShield className="text-gray-400 mr-1" />
                            <span className="text-sm text-gray-500">Unverified</span>
                          </>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">{vendor.name}</div>
                      <div className="text-sm text-gray-500">{vendor.phone}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{vendor.store_name}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 text-xs rounded-full ${getCategoryColor(vendor.category)}`}>
                        {vendor.category}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 text-xs rounded-full ${
                        vendor.vendorType === 'home' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'
                      }`}>
                        {vendor.vendorType}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        {vendor.approval ? (
                          <>
                            <BsCheckCircleFill className="text-green-500 mr-1" />
                            <span className="text-sm text-green-600">Approved</span>
                          </>
                        ) : (
                          <>
                            <BsXCircleFill className="text-red-500 mr-1" />
                            <span className="text-sm text-red-600">Not Approved</span>
                          </>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 text-xs rounded-full ${
                        vendor.registrationComplete ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                      }`}>
                        {vendor.registrationComplete ? 'Complete' : 'Incomplete'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {formatDate(vendor.createdAt)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex items-center gap-3 justify-end">
                        <button
                          onClick={() => viewVendorDetails(vendor)}
                          className="text-blue-600 hover:text-blue-900"
                          title="View details"
                        >
                          <FiEye className="h-5 w-5" />
                        </button>
                        <button
                          onClick={() => openDuplicateModal(vendor)}
                          className="text-purple-600 hover:text-purple-900"
                          title="Duplicate vendor (for a new branch)"
                        >
                          <FiCopy className="h-5 w-5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {vendors.length > 0 && (
          <div className="flex flex-col md:flex-row justify-between items-center mt-6">
            <div className="text-sm text-gray-700 mb-4 md:mb-0">
              Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, totalVendors)} of {totalVendors} vendors
            </div>
            
            <div className="flex items-center space-x-1">
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                className={`px-3 py-1 rounded-md ${
                  currentPage === 1 
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                    : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                }`}
              >
                First
              </button>
              
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-3 py-1 rounded-md ${
                  currentPage === 1 
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                    : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                }`}
              >
                Prev
              </button>
              
              {pagesToShow.map(page => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 rounded-md ${
                    currentPage === page
                      ? 'bg-blue-600 text-white'
                      : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {page}
                </button>
              ))}
              
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-3 py-1 rounded-md ${
                  currentPage === totalPages 
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                    : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                }`}
              >
                Next
              </button>
              
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                className={`px-3 py-1 rounded-md ${
                  currentPage === totalPages 
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                    : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                }`}
              >
                Last
              </button>
            </div>
            
            <div className="mt-4 md:mt-0 flex items-center space-x-2">
              <span className="text-sm text-gray-700">Items per page:</span>
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="border border-gray-300 rounded-md p-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>
        )}
      </div>

      {/* Vendor Details Modal with Tabs */}
      {vendorDetailsModalOpen && selectedVendor && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl shadow-xl w-[95%] max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center border-b pb-5 mb-6">
                <h2 className="text-3xl font-bold text-gray-800">Vendor Details</h2>
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setActiveTab('gallery')}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition font-medium"
                    title="Upload gallery and store images"
                  >
                    <FiUpload className="h-4 w-4" /> Upload Media
                  </button>
                  <button
                    onClick={() => {
                      const vendor = vendorData?.vendor || selectedVendor;
                      openEditVendorModal(vendor);
                    }}
                    className="flex items-center gap-2 px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition font-medium"
                  >
                    <FiEdit className="h-4 w-4" /> Edit Vendor
                  </button>
                  <button
                    onClick={() => {
                      const vendor = vendorData?.vendor || selectedVendor;
                      openDuplicateModal(vendor);
                    }}
                    className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition font-medium"
                    title="Create a new branch with the same services"
                  >
                    <FiCopy className="h-4 w-4" /> Duplicate
                  </button>
                  <button
                    onClick={() => openDeleteVendorModal(vendorData?.vendor || selectedVendor)}
                    className="flex items-center gap-2 px-4 py-2 bg-white text-red-600 border border-red-300 rounded-lg hover:bg-red-50 transition font-medium"
                    title="Permanently delete this vendor"
                  >
                    <FiTrash2 className="h-4 w-4" /> Delete
                  </button>
                  <button
                    onClick={closeVendorDetailsModal}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <FiX className="h-7 w-7" />
                  </button>
                </div>
              </div>

              {/* Tabs Navigation */}
              <div className="border-b border-gray-200 mb-6">
                <nav className="flex flex-wrap -mb-px space-x-8">
                  <button
                    className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center ${
                      activeTab === 'basic'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                    onClick={() => setActiveTab('basic')}
                  >
                    <FiUsers className="mr-2" />
                    Basic Info
                  </button>
                  <button
                    className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center ${
                      activeTab === 'services'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                    onClick={() => setActiveTab('services')}
                  >
                    <FiShoppingBag className="mr-2" />
                    Services & Packages
                  </button>
                  <button
                    className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center ${
                      activeTab === 'specialists'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                    onClick={() => setActiveTab('specialists')}
                  >
                    <FiUsers className="mr-2" />
                    Specialists
                  </button>
                  <button
                    className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center ${
                      activeTab === 'bookings'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                    onClick={() => setActiveTab('bookings')}
                  >
                    <FiCalendar className="mr-2" />
                    Bookings
                  </button>
                  <button
                    className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center ${
                      activeTab === 'reviews'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                    onClick={() => setActiveTab('reviews')}
                  >
                    <FiStar className="mr-2" />
                    Reviews
                  </button>
                  <button
                    className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center ${
                      activeTab === 'gallery'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                    onClick={() => setActiveTab('gallery')}
                  >
                    <FiImage className="mr-2" />
                    Gallery
                  </button>
                </nav>
              </div>

              {/* Loading state for vendor details */}
               {vendorDetailsLoading && (
                 <div className="flex justify-center items-center py-12">
                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                 </div>
               )}

               {/* Basic Info Tab Content (Original Vendor Details) */}
               {activeTab === 'basic' && !vendorDetailsLoading && (
                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                   {/* Vendor Profile Information */}
                   <div className="md:col-span-1 flex flex-col items-center">
                     {selectedVendor.profile_image ? (
                       <img
                         src={selectedVendor.profile_image}
                         alt={selectedVendor.name}
                         className="h-44 w-44 rounded-full object-cover mb-6 border-4 border-gray-200 shadow-md"
                       />
                     ) : (
                       <div className="h-44 w-44 rounded-full bg-gray-200 flex items-center justify-center mb-6 border-4 border-gray-200 shadow-md">
                         <span className="text-4xl font-bold text-gray-400">
                           {selectedVendor.name?.charAt(0)?.toUpperCase() || '?'}
                         </span>
                       </div>
                     )}
                     
                     <h3 className="text-2xl font-semibold text-center mb-1">{selectedVendor.name}</h3>
                     <p className="text-lg text-gray-600 mb-6">{selectedVendor.phone}</p>
                     
                     {/* Approval Actions */}
                     <div className="mt-2 w-full">
                       <div className="flex justify-center gap-3 mb-6">
                         <button
                           onClick={() => updateVendorApproval(selectedVendor._id, true)}
                           disabled={updatingApproval || selectedVendor.approval === true}
                           className={`px-5 py-3 rounded-md text-base font-medium ${
                             selectedVendor.approval === true
                               ? 'bg-green-100 text-green-800 cursor-not-allowed'
                               : 'bg-green-600 text-white hover:bg-green-700'
                           }`}
                         >
                           {updatingApproval ? (
                             <div className="flex items-center space-x-2">
                               <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                               <span>Processing...</span>
                             </div>
                           ) : selectedVendor.approval === true ? 'Currently Approved' : 'Approve Vendor'}
                         </button>
                         
                         <button
                           onClick={() => updateVendorApproval(selectedVendor._id, false)}
                           disabled={updatingApproval || selectedVendor.approval === false}
                           className={`px-5 py-3 rounded-md text-base font-medium ${
                             selectedVendor.approval === false
                               ? 'bg-red-100 text-red-800 cursor-not-allowed'
                               : 'bg-red-600 text-white hover:bg-red-700'}`}
                               >
                                 {updatingApproval ? (
                                   <div className="flex items-center space-x-2">
                                     <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                                     <span>Processing...</span>
                                   </div>
                                 ) : selectedVendor.approval === false ? 'Currently Rejected' : 'Reject Vendor'}
                               </button>
                        <button
                          onClick={() => updateVendorVerified(selectedVendor._id, !selectedVendor.verified)}
                          disabled={updatingVerified}
                          className={`px-5 py-3 rounded-md text-base font-medium ${
                            selectedVendor.verified
                              ? 'bg-blue-100 text-blue-800 hover:bg-blue-200'
                              : 'bg-blue-600 text-white hover:bg-blue-700'
                          }`}
                        >
                          {updatingVerified ? (
                            <div className="flex items-center space-x-2">
                              <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                              <span>Processing...</span>
                            </div>
                          ) : selectedVendor.verified ? 'Mark as Unverified' : 'Verify Vendor'}
                        </button>
                             </div>
                           </div>
         
                           {/* Status Badges */}
                           <div className="w-full space-y-3 mt-4">
                             <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md shadow-sm">
                               <span className="text-base font-medium">Approval Status:</span>
                               <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                                 selectedVendor.approval 
                                   ? 'bg-green-100 text-green-800' 
                                   : 'bg-red-100 text-red-800'
                               }`}>
                                 {selectedVendor.approval ? 'Approved' : 'Not Approved'}
                               </span>
                             </div>
                             
                        <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md shadow-sm">
                          <span className="text-base font-medium">Verification:</span>
                          <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                            selectedVendor.verified
                              ? 'bg-blue-100 text-blue-800'
                              : 'bg-gray-100 text-gray-600'
                          }`}>
                            {selectedVendor.verified ? 'Verified' : 'Unverified'}
                          </span>
                        </div>

                             <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md shadow-sm">
                               <span className="text-base font-medium">Registration:</span>
                               <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                                 selectedVendor.registrationComplete 
                                   ? 'bg-green-100 text-green-800' 
                                   : 'bg-yellow-100 text-yellow-800'
                               }`}>
                                 {selectedVendor.registrationComplete ? 'Complete' : 'Incomplete'}
                               </span>
                             </div>
                             
                             <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md shadow-sm">
                               <span className="text-base font-medium">Category:</span>
                               <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getCategoryColor(selectedVendor.category)}`}>
                                 {selectedVendor.category}
                               </span>
                             </div>
                             
                             <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md shadow-sm">
                               <span className="text-base font-medium">Vendor Type:</span>
                               <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                                 selectedVendor.vendorType === 'home' 
                                   ? 'bg-green-100 text-green-800' 
                                   : 'bg-orange-100 text-orange-800'
                               }`}>
                                 {selectedVendor.vendorType}
                               </span>
                             </div>
                           </div>
                         </div>
         
                         {/* Vendor Details */}
                         <div className="md:col-span-2">
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                             {/* Store Information */}
                             <div className="bg-gray-50 p-5 rounded-lg shadow-sm">
                               <h4 className="font-semibold text-xl mb-4 border-b pb-3 text-gray-800">Store Information</h4>
                               
                               <div className="space-y-4">
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Store Name</p>
                                   <p className="text-lg font-medium">{selectedVendor.store_name || 'Not provided'}</p>
                                 </div>
                            
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Description</p>
                                   <p className="text-lg font-medium">{selectedVendor.description || 'No description available'}</p>
                                 </div>
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Created At</p>
                                   <p className="text-lg font-medium">{formatDate(selectedVendor.createdAt)}</p>
                                 </div>
                               </div>
                             </div>
                             
                             {/* Contact Information */}
                             <div className="bg-gray-50 p-5 rounded-lg shadow-sm">
                               <h4 className="font-semibold text-xl mb-4 border-b pb-3 text-gray-800">Location & Contact</h4>
                               
                               <div className="space-y-4">
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Phone</p>
                                   <p className="text-lg font-medium">{selectedVendor.phone}</p>
                                 </div>
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Email</p>
                                   <p className="text-lg font-medium">{selectedVendor.email || 'Not provided'}</p>
                                 </div>
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Location</p>
                                   <p className="text-lg font-medium">
                                     {selectedVendor.latitude && selectedVendor.longitude
                                       ? (selectedVendor.address || locationName)
                                       : 'Location not set'}
                                   </p>
                                 </div>
                               </div>
                             </div>
                             
                             {/* Working Hours */}
                             <div className="bg-gray-50 p-5 rounded-lg shadow-sm">
                               <h4 className="font-semibold text-xl mb-4 border-b pb-3 text-gray-800">Working Hours</h4>
                               
                               {selectedVendor.working_hours && selectedVendor.working_hours.length > 0 ? (
                                 <div className="space-y-3">
                                   {selectedVendor.working_hours.map((schedule, index) => (
                                     <div key={index} className="flex justify-between items-center">
                                       <span className="text-base font-medium">{schedule.day}:</span>
                                       <span className="text-base">{schedule.open} - {schedule.close}</span>
                                     </div>
                                   ))}
                                 </div>
                               ) : (
                                 <p className="text-base text-gray-500">No working hours set</p>
                               )}
                             </div>
                             
                             {/* Slot Information */}
                             <div className="bg-gray-50 p-5 rounded-lg shadow-sm">
                               <h4 className="font-semibold text-xl mb-4 border-b pb-3 text-gray-800">Booking Configuration</h4>
                               
                               <div className="space-y-4">
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Slot Duration (minutes)</p>
                                   <p className="text-lg font-medium">{selectedVendor.slot_duration || 'Not set'}</p>
                                 </div>
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Slots Per Time</p>
                                   <p className="text-lg font-medium">{selectedVendor.slots_per_time || 'Not set'}</p>
                                 </div>
                               </div>
                             </div>
                           </div>
                           
                           {/* Amenities */}
                           <div className="mt-6 bg-gray-50 p-5 rounded-lg shadow-sm">
                             <h4 className="font-semibold text-xl mb-4 border-b pb-3 text-gray-800">Amenities</h4>
                             
                             {selectedVendor.amenitiesDetails && selectedVendor.amenitiesDetails.length > 0 ? (
                               <div className="flex flex-wrap gap-4">
                                 {selectedVendor.amenitiesDetails.map((amenity, index) => (
                                   <div 
                                     key={index} 
                                     className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-50 border border-blue-100"
                                   >
                                     {amenity.image && (
                                       <img 
                                         src={amenity.image} 
                                         alt={amenity.name}
                                         className="h-6 w-6 rounded-full object-cover"
                                       />
                                     )}
                                     <span className="text-base font-medium text-blue-800">
                                       {amenity.name}
                                     </span>
                                   </div>
                                 ))}
                               </div>
                             ) : (
                               <p className="text-base text-gray-500">No amenities listed</p>
                             )}
                           </div>
                           
                           {/* Bank Details */}
                           <div className="mt-6 bg-gray-50 p-5 rounded-lg shadow-sm">
                             <h4 className="font-semibold text-xl mb-4 border-b pb-3 text-gray-800">Bank Details</h4>
                             
                             {selectedVendor.bank_details && selectedVendor.bank_details.account_number ? (
                               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Account Holder Name</p>
                                   <p className="text-lg font-medium">{selectedVendor.bank_details.account_holder_name || 'Not provided'}</p>
                                 </div>
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Account Number</p>
                                   <p className="text-lg font-medium">
                                     {selectedVendor.bank_details.account_number 
                                       ? `${selectedVendor.bank_details.account_number.substring(0, 4)}...${selectedVendor.bank_details.account_number.substring(selectedVendor.bank_details.account_number.length - 4)}` 
                                       : 'Not provided'}
                                   </p>
                                 </div>
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">IFSC Code</p>
                                   <p className="text-lg font-medium">{selectedVendor.bank_details.ifsc_code || 'Not provided'}</p>
                                 </div>
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Bank Name</p>
                                   <p className="text-lg font-medium">{selectedVendor.bank_details.bank_name || 'Not provided'}</p>
                                 </div>
                                 
                                 <div>
                                   <p className="text-base text-gray-500 mb-1">Branch Name</p>
                                   <p className="text-lg font-medium">{selectedVendor.bank_details.branch_name || 'Not provided'}</p>
                                 </div>
                               </div>
                             ) : (
                               <p className="text-base text-gray-500">No bank details provided</p>
                             )}
                           </div>
                           
                           {/* Store Images */}
                           <div className="mt-6 bg-gray-50 p-5 rounded-lg shadow-sm">
                             <h4 className="font-semibold text-xl mb-4 border-b pb-3 text-gray-800">Store Images</h4>
                             
                             {selectedVendor.store_images && selectedVendor.store_images.length > 0 ? (
                               <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
                                 {selectedVendor.store_images.map((image, index) => (
                                   <div key={index} className="relative">
                                     <img 
                                       src={image.url} 
                                       alt={`Store Image ${index + 1}`} 
                                       className="h-48 w-full object-cover rounded-lg shadow-sm"
                                     />
                                   </div>
                                 ))}
                               </div>
                             ) : (
                               <p className="text-base text-gray-500">No store images uploaded</p>
                             )}
                           </div>
                           
                           {/* Device Information */}
                           <div className="mt-6 bg-gray-50 p-5 rounded-lg shadow-sm">
                             <h4 className="font-semibold text-xl mb-4 border-b pb-3 text-gray-800">Device Information</h4>
                             
                             {selectedVendor.devices && selectedVendor.devices.length > 0 ? (
                               <div className="space-y-3">
                                 {selectedVendor.devices.map((device, index) => (
                                   <div key={index} className="flex items-center">
                                     <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium mr-3 ${
                                       device.deviceType === 'android' 
                                         ? 'bg-green-100 text-green-800' 
                                         : 'bg-blue-100 text-blue-800'
                                     }`}>
                                       {device.deviceType}
                                     </span>
                                     <span className="text-base truncate">{device.fcmToken.substring(0, 20)}...</span>
                                   </div>
                                 ))}
                               </div>
                             ) : (
                               <p className="text-base text-gray-500">No device information</p>
                             )}
                           </div>
                         </div>
                       </div>
                     )}

                     {/* Services, Packages & Add-ons Tab Content */}
                     {activeTab === 'services' && !vendorDetailsLoading && vendorData && (
                       <VendorServicesTab
                         vendorId={selectedVendor._id}
                         vendorData={vendorData}
                         onDataChange={() => viewVendorDetails(selectedVendor)}
                       />
                     )}

                     {/* Specialists Tab Content */}
                     {activeTab === 'specialists' && !vendorDetailsLoading && vendorData && (
                       <SpecialistsTab
                         vendorData={vendorData}
                         vendorId={selectedVendor?._id}
                         onDataChange={() => viewVendorDetails(selectedVendor)}
                       />
                     )}

                     {/* Bookings Tab Content */}
                     {activeTab === 'bookings' && !vendorDetailsLoading && vendorData && (
                       <div>
                         <div className="mb-8">
                           <h3 className="text-xl font-bold mb-4 text-gray-800">Booking Statistics</h3>
                           
                           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                             <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-200">
                               <p className="text-sm text-gray-500 mb-1">Total Bookings</p>
                               <p className="text-2xl font-bold">
                                 {((vendorData.bookingsStats && vendorData.bookingsStats.pending) || 0) + 
                                  ((vendorData.bookingsStats && vendorData.bookingsStats.confirmed) || 0) + 
                                  ((vendorData.bookingsStats && vendorData.bookingsStats.completed) || 0) + 
                                  ((vendorData.bookingsStats && vendorData.bookingsStats.cancelled) || 0)}
                               </p>
                             </div>
                             
                             <div className="bg-white rounded-lg shadow-sm p-4 border border-blue-200">
                               <p className="text-sm text-gray-500 mb-1">Confirmed</p>
                               <p className="text-2xl font-bold text-blue-600">
                                 {(vendorData.bookingsStats && vendorData.bookingsStats.confirmed) || 0}
                               </p>
                             </div>
                             
                             <div className="bg-white rounded-lg shadow-sm p-4 border border-green-200">
                               <p className="text-sm text-gray-500 mb-1">Completed</p>
                               <p className="text-2xl font-bold text-green-600">
                                 {(vendorData.bookingsStats && vendorData.bookingsStats.completed) || 0}
                               </p>
                             </div>
                             
                             <div className="bg-white rounded-lg shadow-sm p-4 border border-red-200">
                               <p className="text-sm text-gray-500 mb-1">Cancelled</p>
                               <p className="text-2xl font-bold text-red-600">
                                 {(vendorData.bookingsStats && vendorData.bookingsStats.cancelled) || 0}
                               </p>
                             </div>
                           </div>
                         </div>
                         
                         <div>
                           <h3 className="text-xl font-bold mb-4 text-gray-800">Recent Bookings</h3>                                                     
                           {vendorData.recentBookings && vendorData.recentBookings.length > 0 ? (
                             <div className="overflow-x-auto">
                               <table className="min-w-full bg-white">
                                 <thead>
                                   <tr className="bg-gray-100 border-b">
                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date & Time</th>
                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Services</th>
                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment</th>
                                   </tr>
                                 </thead>
                                 <tbody className="divide-y divide-gray-200">
                                   {vendorData.recentBookings.map((booking) => (
                                     <tr key={booking._id} className="hover:bg-gray-50">
                                       <td className="px-6 py-4 whitespace-nowrap">
                                         <div className="text-sm font-medium text-gray-900">{booking.userId?.name || 'Anonymous'}</div>
                                         <div className="text-sm text-gray-500">{booking.userId?.phoneNumber || 'No phone'}</div>
                                       </td>
                                       <td className="px-6 py-4 whitespace-nowrap">
                                         <div className="text-sm text-gray-900">
                                           {new Date(booking.bookingDate).toLocaleDateString()}
                                         </div>
                                         <div className="text-sm text-gray-500">{formatTime(booking.timeSlot)}</div>
                                       </td>
                                       <td className="px-6 py-4 whitespace-nowrap">
                                         <div className="text-sm text-gray-500">
                                           {booking.selectedServices.length} services
                                           {booking.selectedPackages && booking.selectedPackages.length > 0 && `, ${booking.selectedPackages.length} packages`}
                                         </div>
                                       </td>
                                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                         ₹{booking.totalAmount}
                                       </td>
                                       <td className="px-6 py-4 whitespace-nowrap">
                                         <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                                           booking.status === 'confirmed' ? 'bg-blue-100 text-blue-800' :
                                           booking.status === 'completed' ? 'bg-green-100 text-green-800' :
                                           booking.status === 'cancelled' ? 'bg-red-100 text-red-800' :
                                           'bg-yellow-100 text-yellow-800'
                                         }`}>
                                           {booking.status.charAt(0).toUpperCase() + booking.status.slice(1)}
                                         </span>
                                       </td>
                                       <td className="px-6 py-4 whitespace-nowrap">
                                         <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                                           booking.paymentStatus === 'paid' ? 'bg-green-100 text-green-800' :
                                           booking.paymentStatus === 'refunded' ? 'bg-purple-100 text-purple-800' :
                                           booking.paymentStatus === 'failed' ? 'bg-red-100 text-red-800' :
                                           'bg-yellow-100 text-yellow-800'
                                         }`}>
                                           {booking.paymentStatus.charAt(0).toUpperCase() + booking.paymentStatus.slice(1)}
                                         </span>
                                       </td>
                                     </tr>
                                   ))}
                                 </tbody>
                               </table>
                             </div>
                           ) : (
                             <p className="text-gray-500 italic">No bookings found</p>
                           )}
                         </div>
                       </div>
                     )}

                     {/* Reviews Tab Content */}
                     {activeTab === 'reviews' && !vendorDetailsLoading && vendorData && (
                       <div>
                         <div className="mb-8">
                           <h3 className="text-xl font-bold mb-4 text-gray-800">Rating Summary</h3>
                           
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                             <div className="bg-white rounded-3xl shadow-card p-6 border border-gray-200">
                               <div className="flex items-center mb-4">
                                 <div className="text-5xl font-bold text-blue-600">
                                   {vendorData.ratingStats && vendorData.ratingStats.avgRating
                                     ? vendorData.ratingStats.avgRating.toFixed(1)
                                     : '0.0'}
                                 </div>
                                 <div className="ml-4">
                                   <div className="flex items-center">
                                     {[...Array(5)].map((_, i) => (
                                       <svg key={i} className={`w-5 h-5 ${i < Math.round(vendorData.ratingStats?.avgRating || 0) ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                         <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                                       </svg>
                                     ))}
                                   </div>
                                   <p className="text-sm text-gray-500 mt-1">
                                     Based on {vendorData.ratingStats?.totalReviews || 0} reviews
                                   </p>
                                 </div>
                               </div>
                               
                               <div className="space-y-2">
                                 <div className="flex items-center">
                                   <span className="text-sm font-medium w-16">5 Stars</span>
                                   <div className="w-full bg-gray-200 rounded-full h-2 mx-2">
                                     <div className="bg-yellow-400 h-2 rounded-full" style={{ 
                                       width: `${vendorData.ratingStats?.totalReviews > 0 
                                         ? (vendorData.ratingStats?.fiveStars / vendorData.ratingStats?.totalReviews) * 100 
                                         : 0}%` 
                                     }}></div>
                                   </div>
                                   <span className="text-sm text-gray-500 w-10">{vendorData.ratingStats?.fiveStars || 0}</span>
                                 </div>
                                 
                                 <div className="flex items-center">
                                   <span className="text-sm font-medium w-16">4 Stars</span>
                                   <div className="w-full bg-gray-200 rounded-full h-2 mx-2">
                                     <div className="bg-yellow-400 h-2 rounded-full" style={{ 
                                       width: `${vendorData.ratingStats?.totalReviews > 0 
                                         ? (vendorData.ratingStats?.fourStars / vendorData.ratingStats?.totalReviews) * 100 
                                         : 0}%` 
                                     }}></div>
                                   </div>
                                   <span className="text-sm text-gray-500 w-10">{vendorData.ratingStats?.fourStars || 0}</span>
                                 </div>
                                 
                                 <div className="flex items-center">
                                   <span className="text-sm font-medium w-16">3 Stars</span>
                                   <div className="w-full bg-gray-200 rounded-full h-2 mx-2">
                                     <div className="bg-yellow-400 h-2 rounded-full" style={{ 
                                       width: `${vendorData.ratingStats?.totalReviews > 0 
                                         ? (vendorData.ratingStats?.threeStars / vendorData.ratingStats?.totalReviews) * 100 
                                         : 0}%` 
                                     }}></div>
                                   </div>
                                   <span className="text-sm text-gray-500 w-10">{vendorData.ratingStats?.threeStars || 0}</span>
                                 </div>
                                 
                                 <div className="flex items-center">
                                   <span className="text-sm font-medium w-16">2 Stars</span>
                                   <div className="w-full bg-gray-200 rounded-full h-2 mx-2">
                                     <div className="bg-yellow-400 h-2 rounded-full" style={{ 
                                       width: `${vendorData.ratingStats?.totalReviews > 0 
                                         ? (vendorData.ratingStats?.twoStars / vendorData.ratingStats?.totalReviews) * 100 
                                         : 0}%` 
                                     }}></div>
                                   </div>
                                   <span className="text-sm text-gray-500 w-10">{vendorData.ratingStats?.twoStars || 0}</span>
                                 </div>
                                 
                                 <div className="flex items-center">
                                   <span className="text-sm font-medium w-16">1 Star</span>
                                   <div className="w-full bg-gray-200 rounded-full h-2 mx-2">
                                     <div className="bg-yellow-400 h-2 rounded-full" style={{ 
                                       width: `${vendorData.ratingStats?.totalReviews > 0 
                                         ? (vendorData.ratingStats?.oneStar / vendorData.ratingStats?.totalReviews) * 100 
                                         : 0}%` 
                                     }}></div>
                                   </div>
                                   <span className="text-sm text-gray-500 w-10">{vendorData.ratingStats?.oneStar || 0}</span>
                                 </div>
                               </div>
                             </div>
                             
                             <div className="bg-white rounded-3xl shadow-card p-6 border border-gray-200">
                               <h4 className="font-bold text-lg mb-4">Recent Reviews</h4>
                               
                               {vendorData.recentReviews && vendorData.recentReviews.length > 0 ? (
                                 <div className="space-y-4 max-h-72 overflow-y-auto">
                                   {vendorData.recentReviews.map((review) => (
                                     <div key={review._id} className="bg-gray-50 p-4 rounded-lg">
                                       <div className="flex justify-between items-start mb-2">
                                         <div className="font-medium">{review.userId?.name || 'Anonymous'}</div>
                                         <div className="flex items-center">
                                           {[...Array(5)].map((_, i) => (
                                             <svg key={i} className={`w-4 h-4 ${i < review.rating ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                               <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                                             </svg>
                                           ))}
                                         </div>
                                       </div>
                                       <p className="text-sm text-gray-600">{review.comment || 'No comment'}</p>
                                       <div className="text-xs text-gray-500 mt-2">
                                         {formatDate(review.createdAt)}
                                       </div>
                                       
                                       {review.images && review.images.length > 0 && (
                                         <div className="mt-3 flex flex-wrap gap-2">
                                           {review.images.map((image, idx) => (
                                             <img 
                                               key={idx}
                                               src={image.url} 
                                               alt={`Review image ${idx + 1}`}
                                               className="w-16 h-16 object-cover rounded"
                                             />
                                           ))}
                                         </div>
                                       )}
                                     </div>
                                   ))}
                                 </div>
                               ) : (
                                 <p className="text-gray-500 italic">No reviews yet</p>
                               )}
                             </div>
                           </div>
                         </div>
                       </div>
                     )}

                     {/* Gallery Tab Content */}
                     {activeTab === 'gallery' && !vendorDetailsLoading && vendorData && (
                       <VendorGalleryTab
                         vendorId={selectedVendor._id}
                         vendorData={vendorData}
                         storeImages={selectedVendor.store_images || []}
                         onGalleryChange={gallery => setVendorData(prev => ({ ...prev, gallery }))}
                         onStoreImagesChange={store_images => {
                           setSelectedVendor(prev => ({ ...prev, store_images }));
                           setVendorData(prev => ({ ...prev, vendor: { ...prev.vendor, store_images } }));
                         }}
                       />
                     )}
                   </div>
                 </div>
               </div>

           )}

           {/* Add Vendor Modal */}
           {showAddVendorModal && (
             <div className="fixed inset-0 bg-half-transparent flex items-center justify-center z-50 p-4">
               <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                 {/* Modal Header */}
                 <div className="sticky top-0 bg-white border-b p-6 flex items-center justify-between z-10">
                   <h2 className="text-xl font-semibold text-gray-900">Add New Vendor</h2>
                   <button
                     onClick={() => { setShowAddVendorModal(false); resetNewVendorForm(); }}
                     className="p-2 hover:bg-gray-100 rounded-full"
                   >
                     <FiX className="w-6 h-6" />
                   </button>
                 </div>

                 {/* Modal Body */}
                 <form onSubmit={handleCreateVendor} className="p-6">
                   {/* Basic Information Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Basic Information</h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                       {/* Phone (Required) */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
                         <input
                           type="tel"
                           required
                           value={newVendor.phone}
                           onChange={(e) => setNewVendor({...newVendor, phone: e.target.value})}
                           placeholder="9876543210"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>

                       {/* Name */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Name</label>
                         <input
                           type="text"
                           value={newVendor.name}
                           onChange={(e) => setNewVendor({...newVendor, name: e.target.value})}
                           placeholder="John Doe"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>

                       {/* Store Name */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Store Name</label>
                         <input
                           type="text"
                           value={newVendor.store_name}
                           onChange={(e) => setNewVendor({...newVendor, store_name: e.target.value})}
                           placeholder="John's Salon"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>

                       {/* Email */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                         <input
                           type="email"
                           value={newVendor.email}
                           onChange={(e) => setNewVendor({...newVendor, email: e.target.value})}
                           placeholder="john@example.com"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>

                       {/* Category */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                         <select
                           value={newVendor.category}
                           onChange={(e) => setNewVendor({...newVendor, category: e.target.value})}
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         >
                           <option value="mens">Mens</option>
                           <option value="womens">Womens</option>
                           <option value="unisex">Unisex</option>
                         </select>
                       </div>

                       {/* Vendor Type */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Type</label>
                         <select
                           value={newVendor.vendorType}
                           onChange={(e) => setNewVendor({...newVendor, vendorType: e.target.value})}
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         >
                           <option value="office">Office (Salon)</option>
                           <option value="home">Home Service</option>
                         </select>
                       </div>

                       {/* Description */}
                       <div className="md:col-span-2">
                         <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                         <textarea
                           value={newVendor.description}
                           onChange={(e) => setNewVendor({...newVendor, description: e.target.value})}
                           placeholder="Premium salon services..."
                           rows="3"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                     </div>
                   </div>

                   {/* Location Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Location</h3>
                     <div className="relative">
                       <label className="block text-sm font-medium text-gray-700 mb-1">Search Address</label>
                       <div className="relative">
                         <input
                           type="text"
                           value={addressSearch}
                           onChange={(e) => {
                             setAddressSearch(e.target.value);
                             searchAddress(e.target.value);
                           }}
                           placeholder="Search for address (e.g., MG Road, Bangalore)"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                         {searchingAddress && (
                           <div className="absolute right-3 top-2.5">
                             <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                           </div>
                         )}
                       </div>

                       {/* Address Suggestions Dropdown */}
                       {addressSuggestions.length > 0 && (
                         <div className="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                           {addressSuggestions.map((suggestion, index) => (
                             <div
                               key={index}
                               onClick={() => handleAddressSelect(suggestion)}
                               className="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                             >
                               <p className="text-sm text-gray-800">{suggestion.display_name}</p>
                             </div>
                           ))}
                         </div>
                       )}

                       {/* Selected Location Display */}
                       {selectedAddress && newVendor.latitude && newVendor.longitude && (
                         <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                           <div className="flex items-start gap-2">
                             <BsCheckCircleFill className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                             <div className="flex-1">
                               <p className="text-sm font-medium text-green-800">Location Selected</p>
                               <p className="text-xs text-green-700 mt-1">{selectedAddress}</p>
                               <p className="text-xs text-green-600 mt-1">
                                 Coordinates: {parseFloat(newVendor.latitude).toFixed(6)}, {parseFloat(newVendor.longitude).toFixed(6)}
                               </p>
                             </div>
                             <button
                               type="button"
                               onClick={() => {
                                 setSelectedAddress('');
                                 setAddressSearch('');
                                 setNewVendor({...newVendor, latitude: '', longitude: ''});
                               }}
                               className="text-green-600 hover:text-green-800"
                             >
                               <FiX className="w-4 h-4" />
                             </button>
                           </div>
                         </div>
                       )}

                       {/* Help Text */}
                       {!selectedAddress && (
                         <p className="mt-2 text-xs text-gray-500">
                           Start typing an address to search. Select from suggestions to auto-fill coordinates.
                         </p>
                       )}
                     </div>
                   </div>

                   {/* Slot Settings Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Slot Settings</h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Slot Duration (minutes)</label>
                         <input
                           type="number"
                           min="15"
                           max="240"
                           value={newVendor.slot_duration}
                           onChange={(e) => setNewVendor({...newVendor, slot_duration: parseInt(e.target.value)})}
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Parallel Slots</label>
                         <input
                           type="number"
                           min="1"
                           max="10"
                           value={newVendor.slots_per_time}
                           onChange={(e) => setNewVendor({...newVendor, slots_per_time: parseInt(e.target.value)})}
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                     </div>
                   </div>

                   {/* Working Hours Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Working Hours</h3>
                     <div className="space-y-3">
                       {newVendor.working_hours.map((wh, index) => (
                         <div key={wh.day} className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg">
                           <label className="flex items-center w-32">
                             <input
                               type="checkbox"
                               checked={wh.isOpen}
                               onChange={(e) => {
                                 const updated = [...newVendor.working_hours];
                                 updated[index].isOpen = e.target.checked;
                                 setNewVendor({...newVendor, working_hours: updated});
                               }}
                               className="mr-2 w-4 h-4 text-blue-600"
                             />
                             <span className="text-sm font-medium">{wh.day}</span>
                           </label>
                           {wh.isOpen && (
                             <>
                               <input
                                 type="time"
                                 value={wh.open}
                                 onChange={(e) => {
                                   const updated = [...newVendor.working_hours];
                                   updated[index].open = e.target.value;
                                   setNewVendor({...newVendor, working_hours: updated});
                                 }}
                                 className="px-3 py-1 border border-gray-300 rounded-lg text-sm"
                               />
                               <span className="text-gray-500">to</span>
                               <input
                                 type="time"
                                 value={wh.close}
                                 onChange={(e) => {
                                   const updated = [...newVendor.working_hours];
                                   updated[index].close = e.target.value;
                                   setNewVendor({...newVendor, working_hours: updated});
                                 }}
                                 className="px-3 py-1 border border-gray-300 rounded-lg text-sm"
                               />
                             </>
                           )}
                           {!wh.isOpen && <span className="text-gray-400 text-sm">Closed</span>}
                         </div>
                       ))}
                     </div>
                   </div>

                   {/* Amenities Section */}
                   {amenitiesList.length > 0 && (
                     <div className="mb-8">
                       <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Amenities</h3>
                       <div className="flex flex-wrap gap-3">
                         {amenitiesList.map(amenity => (
                           <label key={amenity._id} className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100">
                             <input
                               type="checkbox"
                               checked={newVendor.amenities.includes(amenity._id)}
                               onChange={(e) => {
                                 const updated = e.target.checked
                                   ? [...newVendor.amenities, amenity._id]
                                   : newVendor.amenities.filter(id => id !== amenity._id);
                                 setNewVendor({...newVendor, amenities: updated});
                               }}
                               className="w-4 h-4 text-blue-600"
                             />
                             <span className="text-sm">{amenity.name}</span>
                           </label>
                         ))}
                       </div>
                     </div>
                   )}

                   {/* Bank Details Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Bank Details (Optional)</h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Account Holder Name</label>
                         <input
                           type="text"
                           value={newVendor.bank_details.account_holder_name}
                           onChange={(e) => setNewVendor({
                             ...newVendor,
                             bank_details: {...newVendor.bank_details, account_holder_name: e.target.value}
                           })}
                           placeholder="John Doe"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Account Number</label>
                         <input
                           type="text"
                           value={newVendor.bank_details.account_number}
                           onChange={(e) => setNewVendor({
                             ...newVendor,
                             bank_details: {...newVendor.bank_details, account_number: e.target.value}
                           })}
                           placeholder="1234567890"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">IFSC Code</label>
                         <input
                           type="text"
                           value={newVendor.bank_details.ifsc_code}
                           onChange={(e) => setNewVendor({
                             ...newVendor,
                             bank_details: {...newVendor.bank_details, ifsc_code: e.target.value.toUpperCase()}
                           })}
                           placeholder="SBIN0001234"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Bank Name</label>
                         <input
                           type="text"
                           value={newVendor.bank_details.bank_name}
                           onChange={(e) => setNewVendor({
                             ...newVendor,
                             bank_details: {...newVendor.bank_details, bank_name: e.target.value}
                           })}
                           placeholder="State Bank of India"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Branch Name</label>
                         <input
                           type="text"
                           value={newVendor.bank_details.branch_name}
                           onChange={(e) => setNewVendor({
                             ...newVendor,
                             bank_details: {...newVendor.bank_details, branch_name: e.target.value}
                           })}
                           placeholder="Main Branch"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                     </div>
                   </div>

                   {/* Images Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Images</h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                       {/* Profile Image */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-2">Profile Image</label>
                         <div className="flex items-center gap-4">
                           {profileImageFile && (
                             <img
                               src={URL.createObjectURL(profileImageFile)}
                               alt="Profile Preview"
                               className="w-20 h-20 object-cover rounded-lg"
                             />
                           )}
                           <label className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg cursor-pointer">
                             <FiUpload />
                             <span className="text-sm">Upload</span>
                             <input
                               type="file"
                               accept="image/*"
                               onChange={(e) => setProfileImageFile(e.target.files[0])}
                               className="hidden"
                             />
                           </label>
                           {profileImageFile && (
                             <button
                               type="button"
                               onClick={() => setProfileImageFile(null)}
                               className="p-2 text-red-500 hover:bg-red-50 rounded"
                             >
                               <FiTrash2 />
                             </button>
                           )}
                         </div>
                       </div>

                       {/* Store Images */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-2">Store Images (Max 5)</label>
                         <div className="flex flex-wrap items-center gap-2">
                           {storeImageFiles.map((file, index) => (
                             <div key={index} className="relative">
                               <img
                                 src={URL.createObjectURL(file)}
                                 alt={`Store ${index + 1}`}
                                 className="w-16 h-16 object-cover rounded-lg"
                               />
                               <button
                                 type="button"
                                 onClick={() => setStoreImageFiles(storeImageFiles.filter((_, i) => i !== index))}
                                 className="absolute -top-1 -right-1 p-1 bg-red-500 text-white rounded-full text-xs"
                               >
                                 <FiX className="w-3 h-3" />
                               </button>
                             </div>
                           ))}
                           {storeImageFiles.length < 5 && (
                             <label className="w-16 h-16 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg cursor-pointer">
                               <FiPlus className="w-6 h-6 text-gray-400" />
                               <input
                                 type="file"
                                 accept="image/*"
                                 multiple
                                 onChange={(e) => {
                                   const files = Array.from(e.target.files);
                                   const remaining = 5 - storeImageFiles.length;
                                   setStoreImageFiles([...storeImageFiles, ...files.slice(0, remaining)]);
                                 }}
                                 className="hidden"
                               />
                             </label>
                           )}
                         </div>
                       </div>
                     </div>
                   </div>

                   {/* Status Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Status</h3>
                     <div className="flex gap-6">
                       <label className="flex items-center gap-2 cursor-pointer">
                         <input
                           type="checkbox"
                           checked={newVendor.approval}
                           onChange={(e) => setNewVendor({...newVendor, approval: e.target.checked})}
                           className="w-4 h-4 text-blue-600"
                         />
                         <span className="text-sm font-medium">Approved</span>
                       </label>
                       <label className="flex items-center gap-2 cursor-pointer">
                         <input
                           type="checkbox"
                           checked={newVendor.verified}
                           onChange={(e) => setNewVendor({...newVendor, verified: e.target.checked})}
                           className="w-4 h-4 text-blue-600"
                         />
                         <span className="text-sm font-medium">Verified</span>
                       </label>
                     </div>
                   </div>

                   {/* Form Actions */}
                   <div className="flex gap-4 pt-4 border-t">
                     <button
                       type="button"
                       onClick={() => { setShowAddVendorModal(false); resetNewVendorForm(); }}
                       className="flex-1 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium"
                     >
                       Cancel
                     </button>
                     <button
                       type="submit"
                       disabled={addVendorLoading}
                       className="flex-1 px-4 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                     >
                       {addVendorLoading ? (
                         <>
                           <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                           Creating...
                         </>
                       ) : (
                         <>
                           <FiPlus /> Create Vendor
                         </>
                       )}
                     </button>
                   </div>
                 </form>
               </div>
             </div>
           )}

           {/* Edit Vendor Modal */}
           {showEditVendorModal && (
             <div className="fixed inset-0 bg-half-transparent flex items-center justify-center z-50 p-4">
               <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                 {/* Modal Header */}
                 <div className="sticky top-0 bg-white border-b p-6 flex items-center justify-between z-10">
                   <h2 className="text-xl font-semibold text-gray-900">Edit Vendor</h2>
                   <button
                     onClick={() => { setShowEditVendorModal(false); resetEditVendorForm(); }}
                     className="p-2 hover:bg-gray-100 rounded-full"
                   >
                     <FiX className="w-6 h-6" />
                   </button>
                 </div>

                 {/* Modal Body */}
                 <form onSubmit={handleUpdateVendor} className="p-6">
                   {/* Basic Information Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Basic Information</h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                       {/* Phone */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">
                           Phone Number <span className="text-red-500">*</span>
                         </label>
                         <input
                           type="tel"
                           maxLength={10}
                           value={editVendor.phone}
                           onChange={(e) => setEditVendor({...editVendor, phone: e.target.value.replace(/\D/g, '')})}
                           placeholder="10-digit mobile number"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                         <p className="text-xs text-gray-500 mt-1">Must be a unique 10-digit number.</p>
                       </div>

                       {/* Name */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Name</label>
                         <input
                           type="text"
                           value={editVendor.name}
                           onChange={(e) => setEditVendor({...editVendor, name: e.target.value})}
                           placeholder="John Doe"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>

                       {/* Store Name */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Store Name</label>
                         <input
                           type="text"
                           value={editVendor.store_name}
                           onChange={(e) => setEditVendor({...editVendor, store_name: e.target.value})}
                           placeholder="John's Salon"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>

                       {/* Email */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                         <input
                           type="email"
                           value={editVendor.email}
                           onChange={(e) => setEditVendor({...editVendor, email: e.target.value})}
                           placeholder="john@example.com"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>

                       {/* Category */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                         <select
                           value={editVendor.category}
                           onChange={(e) => setEditVendor({...editVendor, category: e.target.value})}
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         >
                           <option value="mens">Mens</option>
                           <option value="womens">Womens</option>
                           <option value="unisex">Unisex</option>
                         </select>
                       </div>

                       {/* Vendor Type */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Type</label>
                         <select
                           value={editVendor.vendorType}
                           onChange={(e) => setEditVendor({...editVendor, vendorType: e.target.value})}
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         >
                           <option value="office">Office (Salon)</option>
                           <option value="home">Home Service</option>
                         </select>
                       </div>

                       {/* Description */}
                       <div className="md:col-span-2">
                         <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                         <textarea
                           value={editVendor.description}
                           onChange={(e) => setEditVendor({...editVendor, description: e.target.value})}
                           placeholder="Premium salon services..."
                           rows="3"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                     </div>
                   </div>

                   {/* Location Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Location</h3>
                     <div className="relative">
                       <label className="block text-sm font-medium text-gray-700 mb-1">Search Address</label>
                       <div className="relative">
                         <input
                           type="text"
                           value={editAddressSearch}
                           onChange={(e) => {
                             setEditAddressSearch(e.target.value);
                             searchEditAddress(e.target.value);
                           }}
                           placeholder="Search for address (e.g., MG Road, Bangalore)"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                         {editSearchingAddress && (
                           <div className="absolute right-3 top-2.5">
                             <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                           </div>
                         )}
                       </div>

                       {/* Address Suggestions Dropdown */}
                       {editAddressSuggestions.length > 0 && (
                         <div className="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                           {editAddressSuggestions.map((suggestion, index) => (
                             <div
                               key={index}
                               onClick={() => handleEditAddressSelect(suggestion)}
                               className="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                             >
                               <p className="text-sm text-gray-800">{suggestion.display_name}</p>
                             </div>
                           ))}
                         </div>
                       )}

                       {/* Selected Location Display */}
                       {editSelectedAddress && editVendor.latitude && editVendor.longitude && (
                         <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                           <div className="flex items-start gap-2">
                             <BsCheckCircleFill className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                             <div className="flex-1">
                               <p className="text-sm font-medium text-green-800">Location Selected</p>
                               <p className="text-xs text-green-700 mt-1">{editSelectedAddress}</p>
                               <p className="text-xs text-green-600 mt-1">
                                 Coordinates: {parseFloat(editVendor.latitude).toFixed(6)}, {parseFloat(editVendor.longitude).toFixed(6)}
                               </p>
                             </div>
                             <button
                               type="button"
                               onClick={() => {
                                 setEditSelectedAddress('');
                                 setEditAddressSearch('');
                                 setEditVendor({...editVendor, latitude: '', longitude: ''});
                               }}
                               className="text-green-600 hover:text-green-800"
                             >
                               <FiX className="w-4 h-4" />
                             </button>
                           </div>
                         </div>
                       )}

                       {/* Help Text */}
                       {!editSelectedAddress && (
                         <p className="mt-2 text-xs text-gray-500">
                           Start typing an address to search. Select from suggestions to auto-fill coordinates.
                         </p>
                       )}
                     </div>
                   </div>

                   {/* Slot Settings Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Slot Settings</h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Slot Duration (minutes)</label>
                         <input
                           type="number"
                           min="15"
                           max="240"
                           value={editVendor.slot_duration}
                           onChange={(e) => setEditVendor({...editVendor, slot_duration: parseInt(e.target.value)})}
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Parallel Slots</label>
                         <input
                           type="number"
                           min="1"
                           max="10"
                           value={editVendor.slots_per_time}
                           onChange={(e) => setEditVendor({...editVendor, slots_per_time: parseInt(e.target.value)})}
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                     </div>
                   </div>

                   {/* Working Hours Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Working Hours</h3>
                     <div className="space-y-3">
                       {editVendor.working_hours.map((wh, index) => (
                         <div key={wh.day} className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg">
                           <label className="flex items-center w-32">
                             <input
                               type="checkbox"
                               checked={wh.isOpen}
                               onChange={(e) => {
                                 const updated = [...editVendor.working_hours];
                                 updated[index].isOpen = e.target.checked;
                                 setEditVendor({...editVendor, working_hours: updated});
                               }}
                               className="mr-2 w-4 h-4 text-blue-600"
                             />
                             <span className="text-sm font-medium">{wh.day}</span>
                           </label>
                           {wh.isOpen && (
                             <>
                               <input
                                 type="time"
                                 value={wh.open}
                                 onChange={(e) => {
                                   const updated = [...editVendor.working_hours];
                                   updated[index].open = e.target.value;
                                   setEditVendor({...editVendor, working_hours: updated});
                                 }}
                                 className="px-3 py-1 border border-gray-300 rounded-lg text-sm"
                               />
                               <span className="text-gray-500">to</span>
                               <input
                                 type="time"
                                 value={wh.close}
                                 onChange={(e) => {
                                   const updated = [...editVendor.working_hours];
                                   updated[index].close = e.target.value;
                                   setEditVendor({...editVendor, working_hours: updated});
                                 }}
                                 className="px-3 py-1 border border-gray-300 rounded-lg text-sm"
                               />
                             </>
                           )}
                           {!wh.isOpen && <span className="text-gray-400 text-sm">Closed</span>}
                         </div>
                       ))}
                     </div>
                   </div>

                   {/* Amenities Section */}
                   {amenitiesList.length > 0 && (
                     <div className="mb-8">
                       <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Amenities</h3>
                       <div className="flex flex-wrap gap-3">
                         {amenitiesList.map(amenity => (
                           <label key={amenity._id} className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100">
                             <input
                               type="checkbox"
                               checked={editVendor.amenities.includes(amenity._id)}
                               onChange={(e) => {
                                 const updated = e.target.checked
                                   ? [...editVendor.amenities, amenity._id]
                                   : editVendor.amenities.filter(id => id !== amenity._id);
                                 setEditVendor({...editVendor, amenities: updated});
                               }}
                               className="w-4 h-4 text-blue-600"
                             />
                             <span className="text-sm">{amenity.name}</span>
                           </label>
                         ))}
                       </div>
                     </div>
                   )}

                   {/* Bank Details Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Bank Details</h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Account Holder Name</label>
                         <input
                           type="text"
                           value={editVendor.bank_details.account_holder_name}
                           onChange={(e) => setEditVendor({
                             ...editVendor,
                             bank_details: {...editVendor.bank_details, account_holder_name: e.target.value}
                           })}
                           placeholder="John Doe"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Account Number</label>
                         <input
                           type="text"
                           value={editVendor.bank_details.account_number}
                           onChange={(e) => setEditVendor({
                             ...editVendor,
                             bank_details: {...editVendor.bank_details, account_number: e.target.value}
                           })}
                           placeholder="1234567890"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">IFSC Code</label>
                         <input
                           type="text"
                           value={editVendor.bank_details.ifsc_code}
                           onChange={(e) => setEditVendor({
                             ...editVendor,
                             bank_details: {...editVendor.bank_details, ifsc_code: e.target.value.toUpperCase()}
                           })}
                           placeholder="SBIN0001234"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Bank Name</label>
                         <input
                           type="text"
                           value={editVendor.bank_details.bank_name}
                           onChange={(e) => setEditVendor({
                             ...editVendor,
                             bank_details: {...editVendor.bank_details, bank_name: e.target.value}
                           })}
                           placeholder="State Bank of India"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Branch Name</label>
                         <input
                           type="text"
                           value={editVendor.bank_details.branch_name}
                           onChange={(e) => setEditVendor({
                             ...editVendor,
                             bank_details: {...editVendor.bank_details, branch_name: e.target.value}
                           })}
                           placeholder="Main Branch"
                           className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                         />
                       </div>
                     </div>
                   </div>

                   {/* Images Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Images</h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                       {/* Profile Image */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-2">Profile Image</label>
                         <div className="flex items-center gap-4">
                           {editProfileImageFile ? (
                             <img
                               src={URL.createObjectURL(editProfileImageFile)}
                               alt="Profile Preview"
                               className="w-20 h-20 object-cover rounded-lg"
                             />
                           ) : editVendor._id && (vendorData?.vendor?.profile_image || selectedVendor?.profile_image) ? (
                             <img
                               src={vendorData?.vendor?.profile_image || selectedVendor?.profile_image}
                               alt="Current Profile"
                               className="w-20 h-20 object-cover rounded-lg"
                             />
                           ) : null}
                           <label className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg cursor-pointer">
                             <FiUpload />
                             <span className="text-sm">{editProfileImageFile ? 'Change' : 'Upload'}</span>
                             <input
                               type="file"
                               accept="image/*"
                               onChange={(e) => setEditProfileImageFile(e.target.files[0])}
                               className="hidden"
                             />
                           </label>
                           {editProfileImageFile && (
                             <button
                               type="button"
                               onClick={() => setEditProfileImageFile(null)}
                               className="p-2 text-red-500 hover:bg-red-50 rounded"
                             >
                               <FiTrash2 />
                             </button>
                           )}
                         </div>
                       </div>

                       {/* Store Images */}
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-2">Store Images</label>
                         <div className="flex flex-wrap items-center gap-2">
                           {/* Existing Store Images */}
                           {existingStoreImages.map((imageUrl, index) => (
                             <div key={`existing-${index}`} className="relative">
                               <img
                                 src={imageUrl}
                                 alt={`Store ${index + 1}`}
                                 className="w-16 h-16 object-cover rounded-lg"
                               />
                               <button
                                 type="button"
                                 onClick={() => setExistingStoreImages(existingStoreImages.filter((_, i) => i !== index))}
                                 className="absolute -top-1 -right-1 p-1 bg-red-500 text-white rounded-full text-xs"
                               >
                                 <FiX className="w-3 h-3" />
                               </button>
                             </div>
                           ))}
                           {/* New Store Images */}
                           {editStoreImageFiles.map((file, index) => (
                             <div key={`new-${index}`} className="relative">
                               <img
                                 src={URL.createObjectURL(file)}
                                 alt={`New Store ${index + 1}`}
                                 className="w-16 h-16 object-cover rounded-lg border-2 border-blue-300"
                               />
                               <button
                                 type="button"
                                 onClick={() => setEditStoreImageFiles(editStoreImageFiles.filter((_, i) => i !== index))}
                                 className="absolute -top-1 -right-1 p-1 bg-red-500 text-white rounded-full text-xs"
                               >
                                 <FiX className="w-3 h-3" />
                               </button>
                             </div>
                           ))}
                           {(existingStoreImages.length + editStoreImageFiles.length) < 5 && (
                             <label className="w-16 h-16 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg cursor-pointer">
                               <FiPlus className="w-6 h-6 text-gray-400" />
                               <input
                                 type="file"
                                 accept="image/*"
                                 multiple
                                 onChange={(e) => {
                                   const files = Array.from(e.target.files);
                                   const remaining = 5 - existingStoreImages.length - editStoreImageFiles.length;
                                   setEditStoreImageFiles([...editStoreImageFiles, ...files.slice(0, remaining)]);
                                 }}
                                 className="hidden"
                               />
                             </label>
                           )}
                         </div>
                       </div>
                     </div>
                   </div>

                   {/* Status Section */}
                   <div className="mb-8">
                     <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b">Status</h3>
                     <div className="flex gap-6">
                       <label className="flex items-center gap-2 cursor-pointer">
                         <input
                           type="checkbox"
                           checked={editVendor.approval}
                           onChange={(e) => setEditVendor({...editVendor, approval: e.target.checked})}
                           className="w-4 h-4 text-blue-600"
                         />
                         <span className="text-sm font-medium">Approved</span>
                       </label>
                       <label className="flex items-center gap-2 cursor-pointer">
                         <input
                           type="checkbox"
                           checked={editVendor.verified}
                           onChange={(e) => setEditVendor({...editVendor, verified: e.target.checked})}
                           className="w-4 h-4 text-blue-600"
                         />
                         <span className="text-sm font-medium">Verified</span>
                       </label>
                       <label className="flex items-center gap-2 cursor-pointer">
                         <input
                           type="checkbox"
                           checked={editVendor.registrationComplete}
                           onChange={(e) => setEditVendor({...editVendor, registrationComplete: e.target.checked})}
                           className="w-4 h-4 text-blue-600"
                         />
                         <span className="text-sm font-medium">Registration Complete</span>
                       </label>
                     </div>
                   </div>

                   {/* Form Actions */}
                   <div className="flex gap-4 pt-4 border-t">
                     <button
                       type="button"
                       onClick={() => { setShowEditVendorModal(false); resetEditVendorForm(); }}
                       className="flex-1 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium"
                     >
                       Cancel
                     </button>
                     <button
                       type="submit"
                       disabled={editVendorLoading}
                       className="flex-1 px-4 py-3 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                     >
                       {editVendorLoading ? (
                         <>
                           <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                           Updating...
                         </>
                       ) : (
                         <>
                           <FiEdit /> Update Vendor
                         </>
                       )}
                     </button>
                   </div>
                 </form>
               </div>
             </div>
           )}

           {/* Delete Vendor Modal (rendered after the details modal so it sits on top) */}
           {deleteTarget && (
             <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
               <div className="bg-white rounded-3xl shadow-xl w-full max-w-lg">
                 <div className="p-6">
                   <div className="flex items-start gap-4">
                     <div className="flex-shrink-0 w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                       <FiTrash2 className="h-6 w-6 text-red-600" />
                     </div>
                     <div>
                       <h2 className="text-2xl font-bold text-gray-800">Delete vendor permanently?</h2>
                       <p className="text-base text-gray-600 mt-1">
                         <span className="font-semibold text-gray-800">
                           {deleteTarget.store_name || deleteTarget.name || deleteTarget.phone}
                         </span>
                         {deleteTarget.phone && (deleteTarget.store_name || deleteTarget.name) ? ` (${deleteTarget.phone})` : ''}
                       </p>
                     </div>
                   </div>

                   <div className="mt-5 p-4 bg-red-50 border border-red-200 rounded-xl text-sm text-red-800 space-y-2">
                     <p className="font-semibold">This cannot be undone. It permanently deletes:</p>
                     <ul className="list-disc pl-5 space-y-1">
                       <li>The vendor account and login</li>
                       <li>All services, packages, add-ons and specialists</li>
                       <li>Gallery, portfolio and customer reviews</li>
                       <li>Wallet transactions and support tickets</li>
                       <li>Customers' favourites for this salon</li>
                     </ul>
                     <p>Past bookings are kept for customers' history. A vendor with upcoming bookings can't be deleted until those are cancelled or completed.</p>
                   </div>

                   <label className="block mt-5 text-sm font-medium text-gray-700">
                     Type <span className="font-mono font-bold text-red-600">DELETE</span> to confirm
                   </label>
                   <input
                     type="text"
                     value={deleteConfirmText}
                     onChange={(e) => setDeleteConfirmText(e.target.value)}
                     disabled={deletingVendor}
                     autoFocus
                     className="mt-1 block w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
                     placeholder="DELETE"
                   />

                   <div className="flex justify-end gap-3 mt-6">
                     <button
                       onClick={closeDeleteVendorModal}
                       disabled={deletingVendor}
                       className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-50"
                     >
                       Cancel
                     </button>
                     <button
                       onClick={handleDeleteVendor}
                       disabled={deleteConfirmText !== 'DELETE' || deletingVendor}
                       className="flex items-center gap-2 px-5 py-2 rounded-lg bg-red-600 text-white font-medium hover:bg-red-700 disabled:bg-red-300 disabled:cursor-not-allowed"
                     >
                       {deletingVendor ? (
                         <>
                           <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                           Deleting...
                         </>
                       ) : (
                         <>
                           <FiTrash2 className="h-4 w-4" /> Delete permanently
                         </>
                       )}
                     </button>
                   </div>
                 </div>
               </div>
             </div>
           )}

           {/* Duplicate Vendor Modal */}
           {showDuplicateModal && duplicateSource && (
             <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
               <div className="bg-white rounded-3xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                 <div className="p-6">
                   <div className="flex justify-between items-center border-b pb-4 mb-5">
                     <div>
                       <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
                         <FiCopy className="text-purple-600" /> Duplicate Vendor
                       </h2>
                       <p className="text-sm text-gray-500 mt-1">
                         Creating a new branch of <span className="font-semibold">{duplicateSource.store_name || duplicateSource.name}</span>.
                         All services, specialists, packages, gallery, portfolio and add-ons will be copied.
                       </p>
                     </div>
                     <button
                       onClick={() => { setShowDuplicateModal(false); resetDuplicateForm(); }}
                       className="text-gray-500 hover:text-gray-700"
                     >
                       <FiX className="h-6 w-6" />
                     </button>
                   </div>

                   <form onSubmit={handleDuplicateVendor} className="space-y-4">
                     <div>
                       <label className="block text-sm font-medium text-gray-700 mb-1">
                         New Phone Number <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="tel"
                         required
                         maxLength={10}
                         value={duplicateForm.phone}
                         onChange={(e) => setDuplicateForm({ ...duplicateForm, phone: e.target.value.replace(/\D/g, '') })}
                         placeholder="10-digit mobile number"
                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                       />
                       <p className="text-xs text-gray-500 mt-1">Must be different from source vendor's phone.</p>
                     </div>

                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Store Name</label>
                         <input
                           type="text"
                           value={duplicateForm.store_name}
                           onChange={(e) => setDuplicateForm({ ...duplicateForm, store_name: e.target.value })}
                           placeholder="e.g. Salon Name - Branch 2"
                           className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                         />
                       </div>
                       <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Owner Name</label>
                         <input
                           type="text"
                           value={duplicateForm.name}
                           onChange={(e) => setDuplicateForm({ ...duplicateForm, name: e.target.value })}
                           className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                         />
                       </div>
                     </div>

                     <div>
                       <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                       <input
                         type="email"
                         value={duplicateForm.email}
                         onChange={(e) => setDuplicateForm({ ...duplicateForm, email: e.target.value })}
                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                       />
                     </div>

                     <div className="relative">
                       <label className="block text-sm font-medium text-gray-700 mb-1">
                         New Branch Address
                       </label>
                       <input
                         type="text"
                         value={duplicateAddressSearch}
                         onChange={(e) => {
                           setDuplicateAddressSearch(e.target.value);
                           searchDuplicateAddress(e.target.value);
                         }}
                         placeholder="Search for the new branch location"
                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                       />
                       {duplicateSearchingAddress && (
                         <div className="absolute right-3 top-9 text-xs text-gray-500">Searching...</div>
                       )}
                       {duplicateAddressSuggestions.length > 0 && (
                         <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded-lg shadow-lg mt-1 max-h-60 overflow-y-auto">
                           {duplicateAddressSuggestions.map((addr) => (
                             <li
                               key={addr.place_id}
                               onClick={() => handleDuplicateAddressSelect(addr)}
                               className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                             >
                               {addr.display_name}
                             </li>
                           ))}
                         </ul>
                       )}
                       {duplicateForm.latitude && duplicateForm.longitude && (
                         <p className="text-xs text-gray-500 mt-1">
                           Coordinates: {duplicateForm.latitude}, {duplicateForm.longitude}
                         </p>
                       )}
                       <p className="text-xs text-gray-500 mt-1">
                         Leave empty to keep source vendor's address.
                       </p>
                     </div>

                     <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 text-sm text-purple-800">
                       <p className="font-medium mb-1">What gets copied:</p>
                       <ul className="list-disc list-inside space-y-0.5 text-xs">
                         <li>All services and sub-services</li>
                         <li>Specialists and their service assignments</li>
                         <li>Packages with their service bundles</li>
                         <li>Gallery and portfolio items</li>
                         <li>Add-ons</li>
                         <li>Working hours, amenities, bank details, store images (image URLs reused)</li>
                       </ul>
                     </div>

                     <div className="flex gap-3 pt-3 border-t">
                       <button
                         type="button"
                         onClick={() => { setShowDuplicateModal(false); resetDuplicateForm(); }}
                         className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium"
                       >
                         Cancel
                       </button>
                       <button
                         type="submit"
                         disabled={duplicateLoading}
                         className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                       >
                         {duplicateLoading ? (
                           <>
                             <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                             Duplicating...
                           </>
                         ) : (
                           <>
                             <FiCopy /> Duplicate Vendor
                           </>
                         )}
                       </button>
                     </div>
                   </form>
                 </div>
               </div>
             </div>
           )}
         </div>
       );
     };

     export default VendorsList;